"use strict";
(function () {
  const PORTRAIT_BUILDER = document.querySelector(".portrait-builder");

  // UTILITIES

  // 🔧 Utility: debounce helper
  function debounce(fn, delay = 300) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  const storeName = "state";
  const SHOP_PAY_BADGE_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="90" height="22" viewBox="0 0 90 22" fill="none">
    <rect width="90" height="22" fill="url(#pattern0_4051_3764)"/>
    <defs>
    <pattern id="pattern0_4051_3764" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use xlink:href="#image0_4051_3764" transform="matrix(0.00149051 0 0 0.00609756 -0.00901084 0)"/>
    </pattern>
    <image id="image0_4051_3764" width="683" height="164" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
    </defs>
    </svg>
	`;

  const scrollIntoView = (element, position = "center") => {
    if (!element) return;
    element.scrollIntoView({
      behavior: "smooth",
      block: position,
    });
  };

  const getEventTarget = (selector, target) => {
    if (!selector || !target) return;
    if (target.classList.contains(selector)) return target;
    return target.closest(selector);
  };

  if (!customElements.get("portrait-steps")) {
    class PortraitSteps extends HTMLElement {
      constructor() {
        super();
        this._currentStep = 1;
        this.maxStep = this.dataset.maxStep || 5;
        this.onClick = this.onClick.bind(this);
        this.elements = {
          nextBtn: null,
          prevBtn: null,
          modal: null,
        };
      }

      static get observedAttributes() {
        return ["data-current-step"];
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === "data-current-step" && oldValue !== newValue) {
          this.updateStepClasses(parseInt(newValue));
        }
      }

      connectedCallback() {
        if (
          !document.querySelector(".pb-message-popup__form-inner")
            ?.classList?.contains("success")
        ) {
          const initialStep = parseInt(
            this.getAttribute("data-current-step") || 1,
          );
          this.updateStepClasses(initialStep);
        }

        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      get currentStep() {
        return this.getAttribute("data-current-step") || this._currentStep;
      }

      set currentStep(value) {
        this.setAttribute("data-current-step", value);
      }

      updateStepClasses(currentStep) {
        const steps = this.querySelectorAll(".portrait-steps__item");

        steps.forEach((step, index) => {
          step.classList.remove("current", "done");

          if (index < currentStep - 1) {
            step.classList.add("done");
          }
        });

        const currentStepElement = steps[currentStep - 1];
        if (currentStepElement) {
          currentStepElement.classList.add("current");
        }
      }
    }

    PortraitSteps.prototype.setupElements = function () {
      this.elements.nextBtn = this.closest(".portrait-builder")?.querySelector(
        ".builder-step-btn--next",
      );
      this.elements.prevBtn = this.closest(".portrait-builder")?.querySelector(
        ".builder-step-btn--prev",
      );
      this.elements.modal = document.querySelector(".pb-message-popup");
    };

    PortraitSteps.prototype.addEventListeners = function () {
      this.addEventListener("click", this.onClick);
    };

    PortraitSteps.prototype.removeEventListeners = function () {
      this.removeEventListener("click", this.onClick);
    };

    PortraitSteps.prototype.onClick = function (e) {
      const target = getEventTarget(".portrait-steps__item", e.target);
      if (!target) return;
      if (this.currentStep == 1) {
        this.openModal();
      }
      const step = target.dataset.step;
      if (!step) return;
      this.dataset.currentStep = step;
      this.updateBuilderClasses(step);
      const changeStepEvent = new CustomEvent("builder:update-summary", {
        bubbles: true,
      });
      this.dispatchEvent(changeStepEvent);
    };

    PortraitSteps.prototype.updateBuilderClasses = function (step) {
      if (!this.builder || !step) return;
      const prevStep = this.builder.querySelector(
        ".portrait-builder-step.current",
      );
      const nextStep = this.builder.querySelector(
        `.portrait-builder-step--${step}`,
      );
      if (prevStep && prevStep != nextStep)
        prevStep.classList.remove("current");
      if (nextStep) nextStep.classList.add("current");

      if (this.elements.nextBtn == null || this.elements.prevBtn == null)
        this.setupElements();
      if (this.elements.nextBtn) {
        if (step == this.maxStep) {
          this.elements.nextBtn.classList.add("submit");
        } else {
          this.elements.nextBtn.classList.remove("submit");
        }
      }

      if (this.elements.prevBtn) {
        if (+step == 1) {
          this.elements.prevBtn.classList.remove("visible");
        } else {
          this.elements.prevBtn.classList.add("visible");
        }
      }
    };

    PortraitSteps.prototype.openModal = function () {
      if (!this.elements.modal) {
        this.elements.modal = document.querySelector(".pb-message-popup");
      }
      const showMessage = sessionStorage.getItem("pb-message-popup");
      if (showMessage == "true") return;
      this.elements?.modal?.showModal();
      sessionStorage.setItem("pb-message-popup", "true");
    };

    PortraitSteps.prototype.builder =
      document.querySelector("portrait-builder");

    customElements.define("portrait-steps", PortraitSteps);
  }

  if (!customElements.get("portrait-builder")) {
    class PortraitBuilder extends HTMLElement {
      constructor() {
        super();
        this.storageState = {
          fetched: false,
          currentVariant: {},
          notifications: [],
          additionalProducts: [],
        };
        this.elements = {
          nextBtn: null,
          summary: null,
          modal: null,
          mainProductPrice: null,
          mainProductComparePrice: null,
        };
        this.additionalProducts = [];
        this.variantData = null;
        this.currentVariant = null;
        this.customBg = null;
        this.downloadedImages = [];
        this.customBackgroundImage = [];
        this.notifications = [];
        this.defaultVariant = +this.dataset?.defaultVariant || null;
        this.currency = this.dataset.currency;
        this.discount = +this.dataset.discount;
        this.onNotificationChange = this.onNotificationChange.bind(this);
        this.onFetch = this.onFetch.bind(this);
        this.onStepChange = this.onStepChange.bind(this);
        this.onRemoveAdditionalProduct =
          this.onRemoveAdditionalProduct.bind(this);
        this.setState = this.setState.bind(this);
      }

      static get observedAttributes() {
        return ["data-quantity"];
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
        if (this.defaultVariant && !this.storageState.fetched) {
          this.setVariantById(this.defaultVariant);
        }

        this.onInit();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === "data-quantity" && oldValue !== newValue) {
          this.updatePrice();
          this._syncDuplicateLine();
          this.updateSummary();
          if (this.storageState.fetched) {
            this.persistState();
          }
        }
      }

      get quantity() {
        return this.dataset.quantity || 0;
      }

      get currentStep() {
        return this.elements?.steps?.dataset?.currentStep || 1;
      }
    }

    PortraitBuilder.prototype.setupElements = function () {
      this.elements.mainProductPrice = document.querySelector(
        "[data-product-price]",
      );
      this.elements.mainProductComparePrice = document.querySelector(
        "[data-compare-price]",
      );
      this.elements.mainProductPricePercentage = document.querySelector(
        "[data-product-price-percentage] span:nth-child(2)",
      );
      this.elements.nextBtn = this.querySelector(".builder-step-btn--next");
      this.elements.steps = this.querySelector(".portrait-steps");
      this.elements.modal = this.querySelector('[data-component="pb-modal"]');
      this.elements.modalClose = this.querySelector(
        '[data-component="pb-modal-close"] ',
      );
      this.elements.tips = this.querySelector(".pb-tips-product");
      this.elements.notifications = this.querySelectorAll(
        '[data-component="notification"]',
      );
      this.elements.options = this.querySelectorAll(
        '[data-component="option"]',
      );
      this.elements.comparePrice = this.querySelector(
        '[data-component="compare-price"]',
      );
      this.elements.save = this.querySelector('[data-component="save"]');
      this.elements.totalPrice = this.querySelector(
        '[data-component="total-price"]',
      );
      this.elements.summary = this.querySelector('[data-component="summary"]');
      this.elements.summaryTemplate = this.querySelector(
        '[data-component="summary"] #pb-summary-item',
      );
      this.elements.productForm = document.querySelector(
        ".product-portrait__grid .product-single__form",
      );
      this.elements.submitBtn = this.elements?.productForm?.querySelector(
        ".add-to-cart.gpofromhere",
      );
    };

    PortraitBuilder.prototype.addEventListeners = function () {
      this.addEventListener("builder:change-purchase", this.onPurchaseChange);
      this.addEventListener("builder:change-step", this.onStepChange);
      this.addEventListener(
        "builder:remove-additional-product",
        this.onRemoveAdditionalProduct,
      );
      this.addEventListener("builder:update-summary", this.updateSummary);

      if (this.elements.notifications?.length > 0) {
        this.elements.notifications.forEach((n) => {
          n.addEventListener("input", this.onNotificationChange);
          n.addEventListener("change", this.onNotificationChange);
        });
      }

      if (this.elements.modal) {
        const btn = this.elements.modal.querySelector(".pb-modal__proceed-btn");
        const overlay = this.elements.modal.querySelector(
          '[data-component="overlay"]',
        );
        if (btn) {
          btn.addEventListener("click", this.setState);
        }
        if (overlay) {
          overlay.addEventListener("click", (e) => {
            this.elements.modal.classList.add("hidden");
          });
        }
      }

      if (this.elements.modalClose) {
        this.elements.modalClose.addEventListener("click", () => {
          this.elements.modal.classList.add("hidden");
          this.resetStorage();
        });
        this.elements.modalClose.addEventListener("keydown", (e) => {
          if (e.key === "Enter") e.target.click();
        });
      }

      window.addEventListener("load", this.onFetch);
    };

    PortraitBuilder.prototype.removeEventListeners = function () {
      this.removeEventListener("builder:change-step", this.onStepChange);
      this.removeEventListener("builder:update-summary", this.updateSummary);

      if (this.elements.notifications?.length > 0) {
        this.elements.notifications.forEach((n) => {
          n.removeEventListener("input", this.onNotificationChange);
          n.removeEventListener("change", this.onNotificationChange);
        });
      }

      if (this.elements.modal) {
        const btn = this.elements.modal.querySelector(".pb-modal__proceed-btn");
        if (btn) {
          btn.removeEventListener("click", this.setState);
        }
      }

      window.removeEventListener("load", this.onFetch);
    };

    PortraitBuilder.prototype.onInit = function () {
      setTimeout(() => {
        this.setCurrentVariant();
        this.updatePrice();

        if (!this.storageState.fetched) return;
        if (!this.defaultVariant) return;

        this.setVariantById(this.defaultVariant);
      }, 2000);
    };

    PortraitBuilder.prototype.onFetch = async function () {
      const data = await getUserData(storeName);
      this.storageState.fetched = true;

      this.storageState = { ...this.storageState, ...data };

      this.onInit();

      const { additionalProducts, notifications, isSubmited, date } = data;
      const currentVariant = data?.currentVariant;

      const continueShopping = data.continueShopping == "true";

      const areSavedValues =
        (currentVariant &&
          currentVariant != "null" &&
          currentVariant != "" &&
          this.currentVariant?.id != currentVariant?.id) ||
        (additionalProducts != "" && additionalProducts?.length > 0) ||
        notifications != "" ||
        notifications?.length > 0;

      // --- Check if saved data is older than 48 hours ---
      if (!date) return;

      const savedTime = new Date(date).getTime();
      const currentTime = Date.now();
      const hours48 = 48 * 60 * 60 * 1000; // 48 hours in ms

      if (
        currentTime - savedTime > hours48 ||
        currentVariant?.productId != this.dataset.productId
      ) {
        saveUserData(storeName, [], [], {}, 0, [], [], "false", "");
        return;
      }

      const messagePopup = sessionStorage.getItem("pb-message-popup");

      // if (isSubmited == "false" || messagePopup != "true") {
      if (messagePopup != "true") {
        this.elements.nextBtn?.classList.add("not-allowed");
      }

      const url = new URL(window.location.href);
      const proceed = url.searchParams.get("proceed");

      const modalIsShown =
        sessionStorage.getItem("pb-modal-is-shown") == "true";
      if (
        continueShopping &&
        this.elements.modal &&
        areSavedValues &&
        !modalIsShown &&
        this.dataset?.productId == currentVariant?.productId
      ) {
        if (
          document.querySelector(".pb-message-popup__form-inner")
            ?.classList?.contains("success")
        ) {
          this.elements.modal.classList.add("hidden");
          sessionStorage.setItem("pb-modal-is-shown", "true");
        } else {
          this.elements.modal.classList.remove("hidden");
          sessionStorage.setItem("pb-modal-is-shown", "true");
        }
      }

      if (proceed === "true") {
        this.elements.modal.classList.add("hidden");
        await new Promise((resolve) =>
          setTimeout(() => {
            sessionStorage.setItem("pb-modal-is-shown", "true");
            this.setState();

            url.searchParams.delete("proceed");
            const cleanUrl =
              url.pathname +
              (url?.searchParams?.toString()
                ? "?" + url.searchParams.toString()
                : "");

            window.history.replaceState({}, "", cleanUrl);

            resolve();
          }, 2000),
        );
      }
    };

    PortraitBuilder.prototype.getVariantData = function () {
      this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector("#portrait-builder-variants").textContent,
        );
      return this.variantData;
    };

    PortraitBuilder.prototype.getOptionsData = function () {
      this.optionsData =
        this.optionsData ||
        JSON.parse(this.querySelector("#portrait-builder-options").textContent);

      return this.optionsData;
    };

    PortraitBuilder.prototype.onPurchaseChange = function (e) {
      const purchaseId = e.detail?.purchaseId;
      if (!purchaseId) {
        console.error("purchaseId is not defined", purchaseId);
        return;
      }
      this.purchaseId = purchaseId;
      this.persistState();
      this.updateSummary();
    };

    PortraitBuilder.prototype.onStepChange = function (e) {
      const step = e.detail?.step;
      if (!step) {
        console.error("Step is not defined", step);
        return;
      }
      this.setActiveStep(step);
    };

    PortraitBuilder.prototype.onRemoveAdditionalProduct = function (e) {
      const productId = +e.detail?.productId;
      const type = e.detail?.type;
      const prevent = e.detail?.prevent;
      if (!productId) return;

      const currentProduct = this.additionalProducts.find((p) => {
        return +productId == p.productId;
      });
      if (!currentProduct) return;

      const { imageSelector, notification } = currentProduct;
      if (imageSelector) this.onImageSelectorRemove(imageSelector, type);
      if (notification) this.onNotificationRemove(notification);

      const productSwitcher = this.querySelector(
        `pb-product-switcher[data-product-id="${productId}"] [data-component="switcher"]`,
      );
      if (productSwitcher && productSwitcher.checked) {
        productSwitcher.checked = false;
        productSwitcher.dispatchEvent(new Event("change", { bubbles: true }));
      }

      this.persistState();
      this.updateSummary();
    };

    PortraitBuilder.prototype.onNotificationRemove = debounce(function (id) {
      if (!id) return;

      const notificationElement = this.querySelector(`#${id}`);
      if (!notificationElement) return;

      notificationElement.value = "";

      notificationElement.dispatchEvent(new Event("input", { bubbles: true }));
      notificationElement.dispatchEvent(new Event("change", { bubbles: true }));
    }, 300);

    PortraitBuilder.prototype.onImageSelectorRemove = function (id, type) {
      if (!id) return;
      const imageSelector = this.querySelector(`#${id}`);
      if (!imageSelector) return;

      if (type == "default") {
        imageSelector.clearAllFiles();
      }
    };

    PortraitBuilder.prototype.onNotificationChange = function (e) {
      const title = e.target?.dataset?.title;
      if (!title) return;

      const currentNotification = this.notifications.find(
        (n) => n.title == title,
      );
      if (!currentNotification) {
        this.notifications.push({ title, value: e.target.value });
      } else {
        currentNotification.value = e.target.value;
      }
      this.updateSummary();
      this.persistState();
    };

    PortraitBuilder.prototype.getSelectedVariantsValues = function () {
      const selectedVariantsPositions = [];
      const selectedVariantsValues = [];
      const options = this.getOptionsData();

      const selectedVariants = this.querySelectorAll(
        '.selected[data-component="value"]',
      );
      selectedVariants.forEach((v) =>
        selectedVariantsPositions.push(v.dataset.optionPosition),
      );
      selectedVariantsPositions.forEach((p, i) =>
        selectedVariantsValues.push(options[i]?.values[+p]),
      );
      return selectedVariantsValues;
    };

    PortraitBuilder.prototype.setCurrentVariant = function () {
      const variants = this.getVariantData();
      const selectedVariantsValues = this.getSelectedVariantsValues();
      this.currentVariant = variants.find((v) => {
        let hasVariant = true;
        v?.options?.forEach((v, i) => {
          if (!hasVariant) return;
          if (v != selectedVariantsValues[i]) hasVariant = false;
        });
        return hasVariant;
      });

      this.currentVariant.productId = +this.dataset?.productId;
      this.currentVariant.handle = this.dataset?.handle;

      if (this.currentVariant && this.elements.productForm) {
        const input =
          this.elements.productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
      }
    };

    PortraitBuilder.prototype.setVariantById = function (id) {
      // Abort any previous pending variant operation
      if (this._variantAbortController) {
        console.warn("🛑 Canceling previous variant operation...");
        this._variantAbortController.abort();
      }

      // Create a new AbortController for the current operation
      this._variantAbortController = new AbortController();
      const signal = this._variantAbortController.signal;

      return new Promise(async (resolve, reject) => {
        try {
          if (!id) {
            console.error("❌ Variant ID is missing:", id);
            return reject(new Error("Variant ID is missing"));
          }

          const variants = this.getVariantData();
          const targetVariant = variants.find((v) => v.id == id);
          if (!targetVariant) {
            console.warn("⚠️ Variant not found for ID:", id);
            return reject(new Error("Variant not found"));
          }

          const options = this.getOptionsData();
          const optionPositions = [];

          options.forEach((opt, i) => {
            const pos = opt.values.findIndex(
              (v) => v === targetVariant.options[i],
            );
            optionPositions.push(pos);
          });

          if (!this.elements?.options || this.elements.options.length === 0) {
            this.elements.options = this.querySelectorAll(
              '[data-component="option"]',
            );
          }

          if (!this.elements.options || this.elements.options.length < 1) {
            console.warn("⚠️ No option elements found in DOM");
            return reject(new Error("No option elements found"));
          }

          for (let i = 0; i < this.elements.options.length; i++) {
            if (signal.aborted) {
              return reject(new DOMException("Aborted", "AbortError"));
            }

            const optionEl = this.elements.options[i];
            const position = optionPositions[i];
            if (position < 0) continue;

            const selected = optionEl.querySelector(
              `[data-option-position="${position}"]`,
            );

            if (!selected) {
              console.warn(
                `⚠️ Option not found for index ${i}, position ${position}`,
              );
              continue;
            }

            selected.click();

            // Wait a bit for UI updates, but stop early if canceled
            await new Promise((resolveStep) => {
              const timeout = setTimeout(resolveStep, 300);
              signal.addEventListener("abort", () => {
                clearTimeout(timeout);
                resolveStep(); // exit early
              });
            });
          }

          if (signal.aborted) {
            return reject(new DOMException("Aborted", "AbortError"));
          }

          resolve(targetVariant);
        } catch (err) {
          if (err.name === "AbortError") {
            console.log("⚠️ Previous variant change aborted.");
          } else {
            console.error("❌ Error in setVariantById:", err);
          }
          reject(err);
        }
      });
    };

    PortraitBuilder.prototype.getOptionsPosition = function (variant) {
      if (!variant) return;
      const variants = this.getVariantData();
    };

    PortraitBuilder.prototype.updatePrice = async function () {
      if (!this.currentVariant) return;

      this.updateMainProductPrice();
      this.updateComparePrice();
      this.updateSave();
      this.updateTotalPrice();
    };

    PortraitBuilder.prototype.formatePrice = function (price) {
      const formattedPrice = (price / 100).toFixed(2);
      return this.currency + formattedPrice;
    };

    PortraitBuilder.prototype.updateTotalPrice = function () {
      if (!this.elements.totalPrice) return;

      let totalPrice;
      const base = +this.currentVariant.price || 0;
      const dupV = this._getDupVariantForSelectedSize();
      const dupBase = dupV ? +dupV.price : base;
      const qty = +this.quantity;
      const restQty = Math.max(0, qty);
      const restTotal = Math.round(
        ((Math.round(dupBase) * restQty) / 100) * (100 - this.discount || 0),
      );
      totalPrice = base + restTotal;

      if (this.additionalProducts.length > 0) {
        const sum = this.additionalProducts.reduce((sum, p) => {
          if (p.__isDuplicate === true) {
            return sum;
          }
          const q = Math.max(1, parseInt(p.quantity || "1", 10));
          return sum + p.price * q;
        }, 0);
        totalPrice = totalPrice + sum;
      }

      this.elements.totalPrice.innerHTML = this.formatePrice(totalPrice);
    };

    PortraitBuilder.prototype._calcDuplicateTotal = function (baseCents, qty) {
      const q = parseInt(qty || 0, 10);
      if (!q || q < 1) return Math.round(+baseCents || 0);
      const first = +baseCents || 0;
      const restUnit = Math.round(first * 0.7);
      return Math.round(first + q * restUnit);
    };

    PortraitBuilder.prototype.updateMainProductPrice = function () {
      const {
        mainProductComparePrice,
        mainProductPrice,
        mainProductPricePercentage,
      } = this.elements;
      if (mainProductComparePrice && this.currentVariant?.compare_at_price) {
        let totalPrice;
        const pricePerItem = this.currentVariant?.price || 0;
        const cap =
          +this.currentVariant?.compare_at_price ||
          +this.currentVariant?.price ||
          0;
        const dupV = this._getDupVariantForSelectedSize();
        const dupCap = dupV ? +dupV.price || cap : cap;
        const qty = this.quantity;
        const restQty = Math.max(0, qty);
        const restTotal =
          dupCap * restQty + restQty * ((dupCap / 100) * this.discount) || 0;
        totalPrice = cap + restTotal;

        if (this.additionalProducts.length > 0) {
          const sum = this.additionalProducts.reduce((sum, p) => {
            if (p.__isDuplicate === true) {
              return sum;
            }
            const q = Math.max(1, parseInt(p.quantity || "1", 10));
            return sum + p.price * q;
          }, 0);
          totalPrice = totalPrice + sum;
        }

        mainProductComparePrice.innerHTML = this.formatePrice(totalPrice);
      }
      if (
        mainProductPricePercentage &&
        this.currentVariant?.compare_at_price &&
        this.currentVariant?.compare_at_price > this.currentVariant.price
      ) {
        const percentage = Math.round(
          ((this.currentVariant.compare_at_price - this.currentVariant.price) /
            this.currentVariant.compare_at_price) *
            100,
        );

        mainProductPricePercentage.innerHTML = `${percentage}%`;
      }

      let totalPrice;
      const base = +this.currentVariant.price || 0;
      const dupV = this._getDupVariantForSelectedSize();
      const dupBase = dupV ? +dupV.price : base;
      const qty = +this.quantity;
      const restQty = Math.max(0, qty);
      const restTotal = Math.round(
        ((Math.round(dupBase) * restQty) / 100) * (100 - this.discount || 0),
      );
      totalPrice = base + restTotal;

      if (this.additionalProducts.length > 0) {
        const sum = this.additionalProducts.reduce((sum, p) => {
          if (p.__isDuplicate === true) {
            return sum;
          }
          const q = Math.max(1, parseInt(p.quantity || "1", 10));
          return sum + p.price * q;
        }, 0);
        totalPrice = totalPrice + sum;
      }

      mainProductPrice.innerHTML = this.formatePrice(totalPrice);
    };

    PortraitBuilder.prototype.updateComparePrice = function () {
      if (!this.elements.comparePrice) return;

      let totalPrice;
      const pricePerItem = this.currentVariant?.price || 0;
      const cap =
        +this.currentVariant?.compare_at_price ||
        +this.currentVariant?.price ||
        0;
      const dupV = this._getDupVariantForSelectedSize();
      const dupCap = dupV ? +dupV.price || cap : cap;
      const qty = this.quantity;
      const restQty = Math.max(0, qty);
      const restTotal =
        dupCap * restQty + restQty * ((dupCap / 100) * this.discount) || 0;
      totalPrice = cap + restTotal;

      if (this.additionalProducts.length > 0) {
        const sum = this.additionalProducts.reduce((sum, p) => {
          if (p.__isDuplicate === true) {
            return sum;
          }
          const q = Math.max(1, parseInt(p.quantity || "1", 10));
          return sum + p.price * q;
        }, 0);
        totalPrice = totalPrice + sum;
      }
      const formatedTotal = this.formatePrice(totalPrice);

      this.elements.comparePrice.innerHTML = formatedTotal;
    };

    //START of Duplicator work
    PortraitBuilder.prototype._getDupVariants = function () {
      if (this._dupVariants) return this._dupVariants;
      const el = this.querySelector("#duplicate-product-variants-full");
      this._dupVariants = el ? JSON.parse(el.textContent) : [];
      return this._dupVariants;
    };

    PortraitBuilder.prototype._getDupSizeOptionIndex = function () {
      if (this._dupSizeIdx != null) return this._dupSizeIdx;
      const optsEl = this.querySelector("#duplicate-product-options");
      const opts = optsEl ? JSON.parse(optsEl.textContent) : [];
      this._dupSizeIdx = opts.findIndex((o) =>
        (o.name || "").toLowerCase().includes("size"),
      );
      return this._dupSizeIdx;
    };

    PortraitBuilder.prototype._getSelectedSizeValue = function () {
      const options = this.getOptionsData();
      const selected = this.getSelectedVariantsValues();
      const idx = options.findIndex((o) =>
        (o.name || "").toLowerCase().includes("size"),
      );
      return idx >= 0 ? selected[idx] : null;
    };

    PortraitBuilder.prototype._getDupVariantForSelectedSize = function () {
      const size = this._getSelectedSizeValue();
      if (!size) return null;
      const dupVars = this._getDupVariants();
      const sizeIdx = this._getDupSizeOptionIndex();
      if (sizeIdx < 0) return null;

      return dupVars.find((v) => {
        return (
          (v.option1 == this.currentVariant.option2 &&
            v.option2.includes(this.currentVariant.option3)) ||
          null
        );
      });
    };

    PortraitBuilder.prototype._syncDuplicateLine = function () {
      const qty = +this.quantity;
      const dupQty = Math.max(0, qty);
      this.additionalProducts = (this.additionalProducts || []).filter(
        (p) => p.__isDuplicate !== true,
      );
      if (dupQty === 0) return;
      const dv = this._getDupVariantForSelectedSize();
      if (!dv) return;
      const filteredArr = this.additionalProducts.filter(
        (p) => p.productId != "duplicate",
      );

      filteredArr.push({
        title: `Duplicate (${this._getSelectedSizeValue()})`,
        price: dv.price,
        variantId: String(dv.id),
        productId: "duplicate",
        quantity: dupQty,
        __isDuplicate: true,
      });
      this.additionalProducts = filteredArr;
    };

    //END of Duplicator work

    PortraitBuilder.prototype.updateSave = function () {
      if (!this.elements.save) return;

      const price = +this.currentVariant.price || 0;
      const cap = +this.currentVariant.compare_at_price || 0;
      let saveCents = 0;
      if (cap > 0) {
        const dupV = this._getDupVariantForSelectedSize();
        const dupPrice = dupV ? +dupV.price || price : price;
        const mainProductSave = cap > price ? Math.round(cap - price) : 0;
        const uiPayCap =
          Math.round((dupPrice / 100) * this.discount) *
          Math.max(+this.quantity, 0);
        saveCents = mainProductSave + uiPayCap;
      }
      this.elements.save.innerHTML = saveCents
        ? `-${this.formatePrice(saveCents)}`
        : "";
    };

    PortraitBuilder.prototype.onVariantUpdate = function () {
      this.setCurrentVariant();
      this._syncDuplicateLine();
      this.updatePrice();
      this.updateSummary();
      if (this.storageState.fetched) this.persistState();
    };

    PortraitBuilder.prototype.addAdditionalProduct = function (product) {
      if (!this.storageState.fetched) {
        this.onFetch();
      }
      if (!product) return;
      this.additionalProducts.push(product);
      this.updatePrice();
      this.updateSummary();
      this.persistState();
    };

    PortraitBuilder.prototype.removeAdditionalProduct = function (product) {
      if (this.additionalProducts?.length == 0 || !product) return;
      this.additionalProducts = this.additionalProducts.filter((p) => {
        return p.variantId != product.variantId;
      });
      this.updatePrice();
      this.updateSummary();
    };

    PortraitBuilder.prototype.updateSummary = function () {
      if (!this.elements.summary || !this.elements.summaryTemplate) return;

      const summaryList = this.elements.summary;
      summaryList.innerHTML = "";

      if (this.elements?.options?.length > 0) {
        this.elements.options;
        this.elements.options.forEach((o, ind) => {
          let title = o.dataset.name;
          const selectedValuePosition =
            o.querySelector(".selected")?.dataset?.optionPosition;
          const options = this.getOptionsData();
          const selectedValue = options[ind]?.values[selectedValuePosition];
          if (!selectedValue) return;
          title = selectedValue ? `${title}` : title;
          summaryList.appendChild(this.createSummaryOption(title, o, ind));
        });
      }

      if (this.notifications?.length > 0) {
        this.notifications.forEach((n) => {
          if (n.value && n.title == "Description")
            summaryList.appendChild(this.createSummaryNotification(n));
        });
      }

      if (this?.downloadedImages?.length > 0) {
        const count = this.downloadedImages.length;
        let label = count === 1 ? "Image" : "Images";

        const li = this.createSummaryImages(
          "Uploaded " + label,
          this?.downloadedImages,
          "Images",
        );
        summaryList.appendChild(li);
      }

      let showQuantity = false;
      if (this.additionalProducts.length > 0) {
        this.additionalProducts.forEach((p) => {
          if (
            p.title.includes("Extra Care") ||
            p.title.includes("Priority") ||
            p.title.includes("File")
          )
            return;
          if (!p.title.toLowerCase().includes("duplicate")) {
            summaryList.appendChild(this.createSummaryAdditionalProduct(p));
          }
          if (
            p.title.toLowerCase().includes("duplicate") &&
            +this.quantity > 0
          ) {
            showQuantity = true;
            summaryList.appendChild(
              this.createSummaryQuantity(
                this.quantity,
                this.currentVariant?.option2,
                this.currentVariant?.option3,
              ),
            );
          } else {
          }
          if (p.title.includes("Heavenly")) {
            if (this.heavenlyImage?.length > 0) {
              summaryList.appendChild(
                this.createSummaryImages(
                  "Make it Heavenly Image",
                  this?.heavenlyImage,
                  "Make it Heavenly Image",
                ),
              );
            }
          }
          if (
            p.title.includes("Custom background") ||
            p.title.includes("Custom Background")
          ) {
            if (this.customBackgroundImage?.length > 0) {
              summaryList.appendChild(
                this.createSummaryImages(
                  "Custom Background Image",
                  this?.customBackgroundImage,
                  "custom-background",
                ),
              );
            }
          }
          if (p.title.includes("Clothing")) {
            if (this.clothingImage?.length > 0) {
              summaryList.appendChild(
                this.createSummaryImages(
                  "Change Clothing Image",
                  this?.clothingImage,
                  "Change Clothing Image",
                ),
              );
            }
          }
        });
      }

      if (!showQuantity && +this.quantity > 0) {
        summaryList.appendChild(
          this.createSummaryItemInstance(`Quantity - ${this.quantity}`),
        );
      }

      if (this.notifications?.length > 0) {
        this.notifications.forEach((n) => {
          if (n.value && n.title != "Description")
            summaryList.appendChild(this.createSummaryNotification(n));
        });
      }

      if (this.additionalProducts.length > 0) {
        const sortedFilteredProducts = this.additionalProducts
          .filter((p) =>
            ["Priority", "Extra Care", "File"].some((keyword) =>
              p.title.toLowerCase().includes(keyword.toLowerCase()),
            ),
          )
          .sort((a, b) => {
            const order = ["Priority", "Extra Care", "File"];
            const getOrder = (title) => {
              const lower = title.toLowerCase();
              for (let i = 0; i < order.length; i++) {
                if (lower.includes(order[i].toLowerCase())) return i;
              }
              return 999; // anything else goes to the end
            };
            return getOrder(a.title) - getOrder(b.title);
          });

        sortedFilteredProducts.forEach((p) => {
          summaryList.appendChild(this.createSummaryAdditionalProduct(p));
        });
      }
    };

    // LOCALE STORAGE start

    PortraitBuilder.prototype.persistState = async function () {
      try {
        const variantPayload = this.currentVariant
          ? {
              id: this.currentVariant.id,
              productId: this.currentVariant?.productId,
              title: this.currentVariant.title,
              price: this.currentVariant.price,
              handle: this.currentVariant?.handle,
              compare_at_price: this.currentVariant.compare_at_price,
              options: this.currentVariant.options,
            }
          : null;

        const timestamp = new Date().toISOString();

        saveUserData(
          storeName,
          this.notifications,
          this.additionalProducts,
          variantPayload,
          this.quantity,
          this.downloadedImages,
          this.customBackgroundImage,
          this.currentStep,
          "true",
          "true",
          this.heavenlyImage,
          this.clothingImage,
          timestamp,
          this.purchaseId,
        );
      } catch (err) {
        console.warn("PB persistState failed:", err);
      }
    };

    PortraitBuilder.prototype.setState = async function () {
      if (this.storageState.currentVariant?.id) {
        await this.setVariantById(this.storageState.currentVariant.id);
      }

      if (this.storageState.notifications.length > 0) {
        const notificationsELements = [...this.elements.notifications];
        this.storageState.notifications.forEach((n) => {
          const currentNotification = notificationsELements.find(
            (notification) => {
              return notification.dataset.title == n.title;
            },
          );

          if (currentNotification) currentNotification.value = n.value;
          currentNotification.dispatchEvent(
            new Event("input", { bubbles: true }),
          );
          currentNotification.dispatchEvent(
            new Event("change", { bubbles: true }),
          );
        });
      }

      if (this.storageState.additionalProducts.length > 0) {
        const additionalProducts = [...this.storageState.additionalProducts];
        additionalProducts.forEach((product) => {
          if (
            this.elements.tips &&
            +this.elements.tips?.dataset?.productId == product.productId
          ) {
            this.elements.tips.setCurrentVariant(product);
          } else {
            const productBlock =
              this.querySelector(
                `pb-product-switcher[data-variant-id="${product.variantId}"]`,
              ) ||
              this.querySelector(
                `pb-product-switcher[data-product-id="${product.productId}"]`,
              );
            if (!productBlock) return;

            const checkbox = productBlock.querySelector(
              '[data-component="switcher"]',
            );
            if (!checkbox || checkbox.checked == true) return;

            checkbox.checked = true;
            checkbox.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      if (
        this.storageState.quantity &&
        this.storageState.quantity != this.quantity
      ) {
        const input = this.querySelector(".pb-quantity__input");
        if (input) {
          input.value = this.storageState.quantity;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      if (
        this.storageState?.customBackgroundImage &&
        this.storageState?.customBackgroundImage?.length > 0
      ) {
        this.updateImage(
          "custom-background",
          this.storageState.customBackgroundImage,
        );
      }
      if (
        this.storageState?.heavenlyImage &&
        this.storageState?.heavenlyImage?.length > 0
      ) {
        this.updateImage(
          "Make it Heavenly Image",
          this.storageState.heavenlyImage,
        );
      }
      if (
        this.storageState?.clothingImage &&
        this.storageState?.clothingImage?.length > 0
      ) {
        this.updateImage(
          "Change Clothing Image",
          this.storageState.clothingImage,
        );
      }

      if (
        this.storageState.step &&
        +this.storageState.step != +this.currentStep &&
        !document.querySelector(".pb-message-popup__form-inner")
          ?.classList?.contains("success")
      ) {
        this.elements.steps.setAttribute(
          "data-current-step",
          this.storageState.step,
        );

        const steps = [...this.querySelectorAll(".portrait-builder-step")];
        const nextBtn = this.querySelector(".builder-step-btn--next");
        const prevBtn = this.querySelector(".builder-step-btn--prev");
        if (steps && steps.length > 0) {
          steps.forEach((step) => {
            if (
              step.classList.contains(
                `portrait-builder-step--${this.storageState.step}`,
              )
            ) {
              step.classList.add("current");
            } else {
              step.classList.remove("current");
            }
          });
        }

        if (this.storageState.step > 1) {
          nextBtn.classList.remove("not-allowed");
          prevBtn.classList.add("visible");
        }

        if (this.storageState.step == 5) {
          nextBtn.classList.add("submit");
        }
      }

      this.elements.modal.classList.add("hidden");

      if (
        this.storageState?.downloadedImages &&
        this.storageState?.downloadedImages?.length > 0
      ) {
        const fetchedImages = [];
        const imageSelector = document.querySelector(
          '.gpo-file[name="Images"]',
        );
        this.storageState.downloadedImages.forEach(async (file) => {
          const resp = await fetch(`${file.imgLink}`);
          if (!resp.ok) throw new Error(`Failed to fetch ${file.imgLink}`);

          const blob = await resp.blob();
          const fetchedFile = new File([blob], file.imgName, {
            type: blob.type,
          });
          fetchedImages.push(fetchedFile);

          if (imageSelector) {
            const dataTransfer = new DataTransfer();
            fetchedImages.forEach((f) => dataTransfer.items.add(f));
            imageSelector.files = dataTransfer.files;
          }
        });

        setTimeout(() => {
          if (this.storageState?.purchaseId) {
            const input = document.querySelector(
              `[data-input-id="${this.storageState.purchaseId.trim()}"]`,
            );
            if (input) input.click();
          }
        }, 10000);

        await new Promise((res) => {
          setTimeout(() => {
            const event = new Event("change", { bubbles: true });
            imageSelector.dispatchEvent(event);
            res();
          }, 3000);
        });
        this.updateSummary();
      }
    };

    PortraitBuilder.prototype.resetStorage = function () {
      saveUserData(storeName, [], [], {}, 0, [], [], "false", "");
    };

    PortraitBuilder.prototype.updateImage = async function (selector, images) {
      const fetchedImages = [];
      const imageSelector = document.querySelector(
        `.gpo-file[name="${selector}"]`,
      );
      images.forEach(async (file) => {
        const resp = await fetch(`${file.imgLink}`);
        if (!resp.ok) throw new Error(`Failed to fetch ${file.imgLink}`);

        const blob = await resp.blob();
        const fetchedFile = new File([blob], file.imgName, {
          type: blob.type,
        });
        fetchedImages.push(fetchedFile);

        if (imageSelector) {
          const dataTransfer = new DataTransfer();
          fetchedImages.forEach((f) => dataTransfer.items.add(f));
          imageSelector.files = dataTransfer.files;
        }
      });

      setTimeout(() => {
        const event = new Event("change", { bubbles: true });
        imageSelector.dispatchEvent(event);
      }, 3000);
    };

    // LOCALE STORAGE end

    PortraitBuilder.prototype.createSummaryItemInstance = function (content) {
      const fragment = this.elements.summaryTemplate.content.cloneNode(true);
      const li = fragment.querySelector("li");
      li.innerHTML = `${content}`;
      return li;
    };

    PortraitBuilder.prototype.createSummaryOption = function (
      title,
      option,
      ind,
    ) {
      const productOptions = this.getOptionsData();
      const optionName = option?.dataset?.name || "";
      const values = [...option.querySelectorAll('[data-component="value"]')];

      const selectOptions = values.reduce((html, v) => {
        const isSelected = v.classList.contains("selected");
        const newHtml =
          html +
          `<option value="${v.dataset.optionPosition}" data-option-position="${v.dataset.optionPosition}" ${isSelected ? "selected" : ""}>
					${productOptions[ind].values[v.dataset.optionPosition]}
				</option>`;
        return newHtml;
      }, "");

      const li = document.createElement("li");
      li.classList.add("pb-summary__item");

      const element = `
				<pb-summary-option class="pb-summary-option">
					<div class="pb-summary-option__title">
						${title}
					</div>
					<div class="pb-summary-option__select-wrapper" data-component="select">
						<select id="pb-summary-select-${ind}" data-name="${optionName}">
							${selectOptions}
						</select>
					</div>
				</pb-summary-option>
			`;

      li.innerHTML = element;
      return li;
    };

    PortraitBuilder.prototype.createSummaryImages = function (
      title,
      images,
      inputName,
    ) {
      if (!images || images.length < 1) return null;
      const li = document.createElement("li");
      const element = images.reduce(
        (html, img, ind, arr) => {
          let newHTML = html;

          newHTML =
            newHTML +
            `
					<div class="pb-summary-images__image-wrapper">
						<a href="${img.imgLink}" target="_blank" rel="noopener noreferrer">
							<span class="pb-summary-images__image-name">${img.imgName}</span>
						</a>
					</div>
				`;
          if (ind + 1 == arr.length) {
            newHTML =
              newHTML +
              `
						</div></pb-summary-images>
					`;
          }
          return newHTML;
        },
        `
				<pb-summary-images class="pb-summary-images" data-file-index="${inputName}">
					<div class="pb-summary-image__top">
						<div class="pb-summary-image__title">${title}</div>
						<button class="pb-summary-image__edit-btn" data-component="edit-btn" tabindex="0">Edit</button>
					</div>
					<div class="pb-summary-image__links">
			`,
      );

      li.classList.add("pb-summary__item", "pb-summary__item--images");
      li.innerHTML = element;
      return li;
    };

    PortraitBuilder.prototype.createSummaryPurchase = function (p) {
      if (!p) return;
    };

    PortraitBuilder.prototype.createSummaryAdditionalProduct = function (p) {
      if (!p) return null;

      let type = p.type ? p.type : "default";
      let isChecked = p.isNotChecked ? "" : "checked";
      let select = "";
      if (p.title.includes("Custom")) {
        type = "radio";
      } else if (p.title.includes("Multiple Photos")) {
        type = "redirect";
      } else if (p.title.includes("Extra Care")) {
        type = "select";
      }

      const li = document.createElement("li");
      li.classList.add(
        "pb-summary__item",
        "pb-summary__item--additional-product",
      );

      if (type == "select") {
        const productElement = document.getElementById(
          `pb-product-${p.productId}`,
        );

        if (productElement) {
          const values = [...productElement.elements?.values];
          if (values && values.length > 0) {
            select = values.reduce((html, value, ind, arr) => {
              let newHTML = html;
              const isChecked = value.classList.contains("selected");

              const { optionPosition } = value.dataset;
              newHTML =
                newHTML +
                `<option value="${optionPosition}" data-option-position="${optionPosition}" ${isChecked ? "selected" : ""}>${value.innerHTML}</option>`;

              if (1 + ind == arr.length) {
                newHTML = newHTML + "</select>";
              }
              return newHTML;
            }, `<select id="pb-summary-select-${p.productId}" class="pb-summary-select" data-component="select">`);
          }
        }
      }

      let btn;
      switch (type) {
        case "default":
          btn =
            '<button class="pb-summary-product__btn" data-component="remove-btn" tabindex="0">Remove</button>';
          break;
        case "redirect":
          btn =
            '<button class="pb-summary-product__btn" data-component="redirect" tabindex="0">Edit</button>';
          break;
        case "select":
          btn = select;
          break;
        default:
          btn =
            '<button class="pb-summary-product__btn" data-component="switcher" tabindex="0">Remove</button>';
          break;
      }

      const html = `
				<pb-summary-product class="pb-summary-product"
					data-title="${p.title}"
					data-product-id="${p.productId}"
					data-type="${type}"
				>
					<span class="pb-summary-product__title">${p.title}</span>
					${btn}
				</pb-summary-product>
			`;

      li.innerHTML = html;
      return li;
    };

    PortraitBuilder.prototype.createSummaryNotification = function (n) {
      if (!n) return;
      const { title, value } = n;

      const li = document.createElement("li");
      li.classList.add("pb-summary__item", "pb-summary__item--notification");
      const textareaId = `summary-${title.toLowerCase().replace(/\s+/g, "-")}`;

      const html = `
				<pb-summary-notification class="pb-summary-notification"
					data-title="${title}"
				>
					<div class="pb-summary-notification__top">
						<div class="pb-sumamry-notification__label">
							${title} - ${value}
						</div>
						<button class="pb-summary-notification__edit-btn" data-component="edit-btn" tabindex="0">
							Edit
						</button>
					</div>
					<div class="pb-summary-notification__wrapper">
						<textarea
							class="pb-summary-notification__textarea"
							data-component="textarea"
							id="${textareaId}"
						>${value}</textarea>
						<button 
							class="pb-summary-notification__save-btn"
							data-component="save-btn"
							tabindex="0"
						>
							Save
						</button>
					</div>
				</pb-summary-notification>
			`;

      li.innerHTML = html;
      return li;
    };

    PortraitBuilder.prototype.createSummaryQuantity = function (
      q,
      option1 = "",
      option2 = "",
    ) {
      if (!q) return;
      let discountText = "";
      if (this.additionalProducts && this.additionalProducts.length > 0) {
        const duplicateProduct = this.additionalProducts.find((p) =>
          p.title.includes("Duplicate"),
        );
        if (duplicateProduct) {
          discountText = "<br>You Save ";
          if (this?.discount > 0) {
            discountText = discountText + `- ${this.discount}% `;
          }
          discountText =
            discountText +
            `- ${this.formatePrice(Math.round(((q * duplicateProduct.price) / 100) * this.discount))}`;
        }
      }

      const title =
        q == 1
          ? `1 Additional ${option1} ${option2}  print ${discountText}`
          : `${q} Additional ${option1} ${option2} prints ${discountText}`;
      const li = document.createElement("li");
      li.classList.add("pb-summary__item", "pb-summary__item--quantity");
      const html = `
				<pb-summary-quantity class="pb-summary-quantity">
					<div class="pb-summary-quantity__title">
						${title} 
					</div>
					<div class="pb-summary-quantity__actions">
						<div class="pb-quantity__wrapper">
            <button class="pb-quantity__btn" data-type="minus" data-component="btn-minus" tabindex="0">-</button>
            <input
              class="pb-quantity__input"
              type="number"
              data-min="0"
              min="0"
              value="${q}"
              data-max="999999"
              data-component="input"
            >
            <button class="pb-quantity__btn" data-type="plus" data-component="btn-plus" tabindex="0">+</button>
          </div>
					</div>
				</pb-summary-quantity>
			`;
      li.innerHTML = html;
      return li;
    };

    PortraitBuilder.prototype.onSubmit = async function () {
      if (this._isSubmitting) return;

      this._isSubmitting = true;
      this.classList.add("submitting");
      //Trying to get previous cart to check items there
      const fetchCart = async () => {
        const res = await fetch("/cart.js", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
        });
        if (!res.ok) throw new Error("Failed to fetch cart");
        return res.json();
      };

      const cart = await fetchCart();
      // this.resetStorage();
      try {
        const res = await fetch("/cart/clear.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
        });

        if (res.ok) {
          console.log("Cart cleared successfully");
        } else {
          console.error("Failed to clear the cart");
        }
      } catch (error) {
        console.error("Error while clearing the cart:", error);
      }

      //SAVING OTHER PRODUCTS
      const variants = this.getVariantData();
      const options = this.getOptionsData();
      const variantIds = variants.map((variant) => variant.id);
      const optionIds = options.flatMap((option) =>
        option.values.map((value) => value.id),
      );
      //TO ADD ADITIONAL DATA VARIANTS
      const specialVariantIds = [
        47262638801150, 43657560129790, 47244611911934, 47262696931582,
        47262693458174, 47262638833918, 47259530658046, 47278623228158,
        47252491469054, 47252490780926, 47252491993342, 44289346306302,
        47244612075774,
      ];
      const itemsToKeep = cart.items.filter(
        (item) =>
          !variantIds.includes(item.variant_id) &&
          !optionIds.includes(item.variant_id) &&
          !specialVariantIds.includes(item.variant_id),
      );

      //MAIN PRODUCT
      const count = this.downloadedImages.length;
      let label = count === 1 ? "Image" : "Images";
      if (itemsToKeep.length > 0) {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: itemsToKeep }),
        });
        if (res.ok) {
          console.log(
            "Items not in the variant/options lists added back to the cart.",
          );
        }
      }
      const images = [];
      images.unshift(...this.downloadedImages);
      if (this.heavenlyImage && this.heavenlyImage.length > 0) {
        images.unshift(...this.heavenlyImage);
      }
      if (this.clothingImage && this.clothingImage.length > 0) {
        images.unshift(...this.clothingImage);
      }
      if (this.customBackgroundImage && this.customBackgroundImage.length > 0) {
        images.unshift(...this.customBackgroundImage);
      }
      const wrappedProperties = images.reduce((acc, image, index) => {
        acc[`Image ${index + 1}`] = image.imgLink;
        return acc;
      }, {});

      let sellingPlanId = null;
      const sellingPlan = document.querySelector("#selected-purchase-option");
      if (sellingPlan) sellingPlanId = +sellingPlan.value;

      //ADDITIONAL PRODUCTS
      const items = [];

      const additionalItems = (this.additionalProducts || [])
        .filter((p) => p?.variantId)
        .map((p) => {
          const item = {
            id: parseInt(p.variantId, 10),
            quantity: Math.max(1, parseInt(p.quantity || "1", 10)),
            properties: {
              main_product_id: this.dataset.productId,
            },
          };

          if (sellingPlanId) {
            let productSellingPlanId = null;

            const productSwitcher = this.querySelector(
              `pb-product-switcher[data-product-id="${p.productId}"]`,
            );

            const sellingPlanData = productSwitcher?.getSellingPlanData();
            if (sellingPlanData && sellingPlanData?.length > 0) {
              const sellingGroup = sellingPlanData.find((sellingGroup) => {
                return sellingGroup?.selling_plans.find(
                  (p) => p?.id == sellingPlanId,
                );
              });

              if (sellingGroup) {
                productSellingPlanId = sellingPlanId;
              }
            }

            if (productSellingPlanId) {
              item.selling_plan = productSellingPlanId;
            }
          }

          return item;
        });
      items.unshift(...additionalItems);
      if (items.length > 0) {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });
      }
      if (!this.elements.productForm || this.elements?.submitBtn) {
        this.elements.productForm = document.querySelector(
          ".product-portrait__grid .product-single__form",
        );
        this.elements.submitBtn = this.elements?.productForm?.querySelector(
          ".add-to-cart.gpofromhere",
        );
      }

      this.injectNotificationInputs();
      this._isSubmitting = false;
      const form = this.elements?.productForm;

      if (form) {
        form.dispatchEvent(
          new Event("submit", { bubbles: true, cancelable: true }),
        );
        form.submit();
      }
    };

    PortraitBuilder.prototype.setActiveStep = function (step) {
      const nextStep = step > 5 ? 5 : step < 1 ? 1 : +step;
      if (this.elements.steps) {
        this.elements.steps.setAttribute("data-current-step", nextStep);
      }

      const steps = [...this.querySelectorAll(".portrait-builder-step")];
      const nextBtn = this.querySelector(".builder-step-btn--next");
      const prevBtn = this.querySelector(".builder-step-btn--prev");
      if (steps && steps.length > 0) {
        steps.forEach((step) => {
          if (step.classList.contains(`portrait-builder-step--${nextStep}`)) {
            step.classList.add("current");
          } else {
            step.classList.remove("current");
          }
        });
      }

      if (nextStep > 1) {
        nextBtn.classList.remove("not-allowed");
        prevBtn.classList.add("visible");
      }

      if (nextStep == 5) {
        nextBtn.classList.add("submit");
      }
    };

    PortraitBuilder.prototype.injectNotificationInputs = function () {
      if (!this.elements.productForm) return;

      // Clean previously injected (if any)
      this.elements.productForm
        .querySelectorAll('input[data-pb-notify="true"]')
        .forEach((el) => el.remove());

      if (!Array.isArray(this.notifications) || this.notifications.length === 0)
        return;

      this.notifications.forEach((n) => {
        if (!n?.title) return;
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[${n.title}]`;
        input.value = n?.value ?? "";
        input.setAttribute("data-pb-notify", "true");
        this.elements.productForm.appendChild(input);
      });
    };

    PortraitBuilder.prototype.getSellingPlanData = function () {
      try {
        const el = this.querySelector(`#pb-selling-plan`);
        if (!el) {
          this.sellingPlanData = null;
          return null;
        }

        const text = el.textContent?.trim();
        if (!text) {
          this.sellingPlanData = null;
          return null;
        }

        this.sellingPlanData = this.sellingPlanData || JSON.parse(text);
        return this.sellingPlanData;
      } catch (error) {
        console.error(`Error parsing selling plan data:`, error);
        this.sellingPlanData = null;
        return null;
      }
    };

    customElements.define("portrait-builder", PortraitBuilder);
  }

  if (!customElements.get("builder-step-btn")) {
    class StepBtn extends HTMLElement {
      constructor() {
        super();
        this.type = this.dataset.type;
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
        this.onInit();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    }

    StepBtn.prototype.setupElements = function () {
      this.steps = document.querySelector(".portrait-steps");
      this.builder = document.querySelector(".portrait-builder");
      this.popup = document.querySelector("pb-message-popup");
    };

    StepBtn.prototype.addEventListeners = function () {
      this.addEventListener("click", this.onClick);
      this.addEventListener("keydown", this.onKeyDown);
    };

    StepBtn.prototype.removeEventListeners = function () {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("keydown", this.onKeyDown);
    };

    StepBtn.prototype.onInit = function () {
      const showModal = sessionStorage.getItem("pb-message-popup");
      if (
        this.type == "next" &&
        this.steps?.dataset?.currentStep == "1" &&
        showModal != "true"
      ) {
        this.classList.add("not-allowed");
      }
    };

    StepBtn.prototype.onKeyDown = function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.onClick();
      }
    };

    StepBtn.prototype.increase = function (currentStep, maxStep) {
      if (!currentStep || !this.builder) return;

      if (+currentStep == +maxStep || this.steps?.dataset?.currentStep == "5") {
        this.builder.onSubmit();
        return;
      }

      const nextStep = 1 + +currentStep;
      if (+nextStep > 1) {
        document.querySelectorAll('.builder-step-btn[data-type="prev"]')
          ?.forEach((btn) => btn.classList.add("visible"));
      } else {
        document.querySelectorAll('.builder-step-btn[data-type="prev"]')
          ?.forEach((btn) => btn.classList.remove("visible"));
      }

      if (nextStep === +maxStep) {
        this.classList.add("submit");
      } else {
        if (+currentStep != +maxStep) this.classList.remove("submit");
      }

      this.steps.setAttribute("data-current-step", nextStep);

      if (+currentStep < +maxStep) {
        const nextStepItem = this.builder.querySelector(
          `.portrait-builder-step--${nextStep}`,
        );

        if (nextStepItem) {
          this.builder
            .querySelectorAll(`.portrait-builder-step`)
            ?.forEach((btn) => btn.classList.remove("current"));
          nextStepItem.classList.add("current");
        }
      }
    };

    StepBtn.prototype.decrease = function (currentStep) {
      if (!currentStep) return;
      const prevStep = +currentStep - 1;

      this.steps.setAttribute("data-current-step", prevStep);

      const currentStepItem = this.builder.querySelector(
        `.portrait-builder-step--${currentStep}`,
      );
      const prevStepItem = this.builder.querySelector(
        `.portrait-builder-step--${prevStep}`,
      );

      if (currentStepItem) {
        currentStepItem.classList.remove("current");
      }

      if (prevStepItem) {
        prevStepItem.classList.add("current");
      }

      document.querySelectorAll("builder-step-btn")
        ?.forEach((btn) => btn.classList.remove("submit"));
      if (prevStep == 1) {
        document.querySelectorAll('.builder-step-btn[data-type="prev"]')
          ?.forEach((btn) => btn.classList.remove("visible"));
      }
    };

    StepBtn.prototype.onClick = function () {
      const showModal = sessionStorage.getItem("pb-message-popup");
      if (showModal == "true") {
        this.classList.remove("not-allowed");
      }

      if (this.classList.contains("not-allowed") && this.popup) {
        this.popup.showModal();
      }

      if (!this.steps) return;

      if (!this.classList.contains("submit")) {
        const price = document.querySelector(
          ".product-portrait__grid .pp-product-single__title",
        );

        scrollIntoView(price, "start");
      }

      const { currentStep, maxStep } = this.steps.dataset;
      if (currentStep == 4) {
        this.steps.dataset.finished = true;
      }
      if (this.type == "next") {
        if (this.steps.dataset.finished) {
          this.increase(4, maxStep);
        } else {
          this.increase(currentStep, maxStep);
        }
      } else {
        this.decrease(currentStep);
      }

      if (this.type === "next") {
        this.classList.add("active");
        setTimeout(() => {
          this.classList.remove("active");
        }, 500);
      }
    };

    customElements.define("builder-step-btn", StepBtn);
  }

  if (!customElements.get("pb-option")) {
    class PbOption extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    }

    PbOption.prototype.addEventListeners = function () {
      this.addEventListener("click", this.onClick);
      this.addEventListener("keydown", this.onKeyDown);
    };

    PbOption.prototype.removeEventListeners = function () {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("keydown", this.onKeyDown);
    };

    PbOption.prototype.onKeyDown = function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault(); // Prevent default action for Enter/Space
        const target = this.getEventTarget(
          '[data-component="value"]',
          e.target,
        );
        if (target && !target.classList.contains("selected")) {
          this.selectOption(target);
        }
      }
    };

    PbOption.prototype.onClick = function (e) {
      const target = getEventTarget('[data-component="value"]', e.target);
      if (!target || target?.classList?.contains("selected")) return;

      const siblings = this.querySelectorAll('[data-component="value"]');
      siblings.forEach((el) => el.classList.remove("selected"));
      target.classList.add("selected");

      if (this.builder) {
        this.builder.onVariantUpdate();
        this.builder.persistState();
        this.builder.updateSummary();
      }
    };

    PbOption.prototype.builder = document.querySelector("portrait-builder");

    customElements.define("pb-option", PbOption);
  }

  if (!customElements.get("pb-image-selector")) {
    class PbImageSelector extends HTMLElement {
      constructor() {
        super();
        this.nextBtn = null;
        this.images = [];
        this.message = null;
        this.maxFiles = this.dataset?.max || 1;
      }

      connectedCallback() {
        this.setupElements();
        this.ensureFileInput();
        this.addEventListeners();
        this.addObservers();
      }

      disconnectedCallback() {
        this.removeEventListeners();
        this.teardownObjectURLs();
        this.removeObservers();
      }
    }

    // --- Setup / teardown ---
    PbImageSelector.prototype.setupElements = function () {
      this.message = this.querySelector('[data-component="message"]');
      this.nextBtn = document.querySelector(
        'builder-step-btn[data-type="next"]',
      );
      this.dropzone = this.querySelector('[data-component="dropzone"]');
      this.btn = this.querySelector('[data-component="btn"]');
      this.results = this.querySelector('[data-component="results"]');
      this.template = this.querySelector("#pb-image-selector-template");
      this.multipleImagesSwitcher = document.querySelector(
        'pb-product-switcher[data-type="multiple-images"]',
      );
      this.productForm = document.querySelector(`.product-single__form`);
      this.inputGroup = document.querySelector(
        `.gpo-element:has(input[name="${this.dataset.input}"])`,
      );
      this.input = document.querySelector(
        `.gpo-dropzone input[name="${this.dataset.input}"]`,
      );
      this.inputDropzone = document.querySelector(
        `.gpo-dropzone:has(input[name="${this.dataset.input}"])`,
      );
      this.inputBtn = document.querySelector(
        `.gpo-dropzone:has(input[name="${this.dataset.input}"]) .gpo-dropzone__action`,
      );

      if (!this.template) {
        const tpl = document.createElement("template");
        tpl.id = "pb-image-selector-template";
        tpl.innerHTML = `
					<div class="pb-image-selector__image-wrapper">
						<div class="pb-image-selector__image"></div>
						<div class="pb-image-selector__image-label"></div>
						<button type="button" class="pb-image-selector__remove">✕</button>
					</div>
				`;
        this.results.appendChild(tpl);
        this.template = tpl;
      }
    };

    PbImageSelector.prototype.ensureFileInput = function () {
      if (!this.fileInput) {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.multiple = true;
        input.style.display = "none";
        this.appendChild(input);
        this.fileInput = input;
      }
    };

    // --- Event listeners wiring ---
    PbImageSelector.prototype.addEventListeners = function () {
      this._onBtnClick = this.onBtnClick.bind(this);
      this._onFileChange = this.onFileChange.bind(this);
      this._onDragOver = this.onDragOver.bind(this);
      this._onDragEnter = this.onDragEnter.bind(this);
      this._onDragLeave = this.onDragLeave.bind(this);
      this._onDrop = this.onDrop.bind(this);
      this._onResultsClick = this.onResultsClick.bind(this);

      if (this.btn) this.btn.addEventListener("click", this._onBtnClick);
      if (this.fileInput)
        this.fileInput.addEventListener("change", this._onFileChange);

      if (this.dropzone) {
        this.dropzone.addEventListener("dragover", this._onDragOver);
        this.dropzone.addEventListener("dragenter", this._onDragEnter);
        this.dropzone.addEventListener("dragleave", this._onDragLeave);
        this.dropzone.addEventListener("drop", this._onDrop);
      }

      if (this.results) {
        this.results.addEventListener("click", this._onResultsClick);
      }
    };

    PbImageSelector.prototype.removeEventListeners = function () {
      if (this.btn) this.btn.removeEventListener("click", this._onBtnClick);
      if (this.fileInput)
        this.fileInput.removeEventListener("change", this._onFileChange);

      if (this.dropzone) {
        this.dropzone.removeEventListener("dragover", this._onDragOver);
        this.dropzone.removeEventListener("dragenter", this._onDragEnter);
        this.dropzone.removeEventListener("dragleave", this._onDragLeave);
        this.dropzone.removeEventListener("drop", this._onDrop);
      }

      if (this.results) {
        this.results.removeEventListener("click", this._onResultsClick);
      }
    };

    PbImageSelector.prototype.addObservers = function () {
      if (!this.productForm) return;

      this.observer = new MutationObserver(() => {
        if (!this.inputGroup)
          this.inputGroup = document.querySelector(
            `.gpo-element:has(input[name="${this.dataset.input}"])`,
          );
        const cards = this.inputGroup.querySelectorAll(".gpo-f-card");
        this.files = Array.from(cards).map((card) => {
          const imgLink = card.querySelector("a.gpo-f-link")?.href || "";
          const fileIndex = card.dataset.fIndex || null;
          const imgName =
            card.querySelector(".gpo-f-name")?.textContent?.trim() || "";
          return {
            element: card,
            imgLink,
            fileIndex,
            imgName,
          };
        });
        this.render();
        PORTRAIT_BUILDER.updateSummary();
      });

      this.observer.observe(this.productForm, {
        childList: true,
        subtree: true, // in case nested changes matter
      });
    };

    PbImageSelector.prototype.removeObservers = function () {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    };

    // --- Handlers: button & input ---
    PbImageSelector.prototype.onBtnClick = function () {
      const realInput =
        this.input ||
        document.querySelector(
          `.gpo-dropzone input[name="${this.dataset.input}"]`,
        );

      const currentCount = Array.isArray(this.files) ? this.files.length : 0;

      if (currentCount >= this.maxFiles) {
        this.showLimitMessage(
          `You can upload a maximum of ${this.maxFiles} images. Remove some to add more.`,
        );
        return;
      }

      this.hideLimitMessage();

      // --- Create temporary input (isolated from GPO) ---
      const tempInput = document.createElement("input");
      tempInput.type = "file";
      tempInput.accept =
        "image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif";
      tempInput.multiple = true;
      tempInput.style.display = "none";
      document.body.appendChild(tempInput);

      const cleanup = () => {
        // Ensure cleanup is safe and idempotent
        tempInput.removeEventListener("change", onTempChange);
        if (tempInput.parentNode) tempInput.parentNode.removeChild(tempInput);
      };

      const onTempChange = (e) => {
        const selectedFiles = Array.from(e.target.files || []);
        cleanup();
        if (selectedFiles.length === 0) return;

        const remainingSlots = this.maxFiles - currentCount;

        if (selectedFiles.length > remainingSlots) {
          this.showLimitMessage(
            `Only ${this.maxFiles} images can be uploaded.`,
          );
        }

        const acceptedFiles = selectedFiles.slice(0, remainingSlots);

        if (realInput) {
          const dataTransfer = new DataTransfer();
          acceptedFiles.forEach((file) => dataTransfer.items.add(file));
          realInput.files = dataTransfer.files;

          this.images = acceptedFiles.map((file) => ({
            name: file.name,
            size: file.size,
            type: file.type,
            url: URL.createObjectURL(file),
          }));

          this.render();
          this.emitChanged();

          const event = new Event("change", { bubbles: true });
          realInput.dispatchEvent(event);
        }
      };

      tempInput.addEventListener("change", onTempChange, { once: true });

      // --- Click must come after listener is bound ---
      tempInput.click();

      // --- Fail-safe cleanup if user cancels (no change fired) ---
      setTimeout(() => cleanup(), 30000); // 30s safety window
    };

    PbImageSelector.prototype.onFileChange = function (e) {
      const files = Array.from(e.target.files || []);
      e.target.value = "";
    };

    // --- Handlers: drag & drop ---
    PbImageSelector.prototype.onDragOver = function (e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    };

    PbImageSelector.prototype.onDragEnter = function (e) {
      e.preventDefault();
      if (this.dropzone) this.dropzone.classList.add("is-dragover");
    };

    PbImageSelector.prototype.onDragLeave = function (e) {
      if (!this.dropzone) return;
      if (e.target === this.dropzone)
        this.dropzone.classList.remove("is-dragover");
    };

    PbImageSelector.prototype.onDrop = function (e) {
      e.preventDefault();
      if (this.dropzone) this.dropzone.classList.remove("is-dragover");

      const files = Array.from(e.dataTransfer.files || []);
      if (files.length === 0) return;

      const currentCount = Array.isArray(this.files) ? this.files.length : 0;
      const remainingSlots = this.maxFiles - currentCount;

      if (remainingSlots <= 0) {
        this.showLimitMessage(
          `You can upload up to ${this.maxFiles} images only.`,
        );
        return;
      }

      const acceptedFiles = files.slice(0, remainingSlots);

      if (acceptedFiles.length < files.length) {
        this.showLimitMessage(
          `Only ${this.maxFiles} image${+this.maxFiles > 1 ? "s" : ""} can be uploaded.`,
        );
      } else {
        this.hideLimitMessage();
      }

      if (this.input) {
        const dataTransfer = new DataTransfer();
        acceptedFiles.forEach((file) => dataTransfer.items.add(file));
        this.input.files = dataTransfer.files;

        const event = new Event("change", { bubbles: true });
        this.input.dispatchEvent(event);
      }
    };

    // --- Results click handler (remove btn) ---
    PbImageSelector.prototype.onResultsClick = function (e) {
      const btn = e.target.closest(".pb-image-selector__remove");
      if (!btn) return;

      this.hideLimitMessage();

      const wrapper = btn.closest(".pb-image-selector__image-wrapper");
      if (!wrapper) return;

      const index = parseInt(wrapper.dataset.index, 10);
      if (isNaN(index)) return;

      const removed = this.images.splice(index, 1)[0];
      if (removed) {
        try {
          URL.revokeObjectURL(removed.url);
        } catch (_) {}
        this.render();
        this.emitChanged();
        this.dispatchEvent(
          new CustomEvent("images:removed", {
            bubbles: true,
            detail: { removed, index },
          }),
        );
      }
    };

    // --- Loading helper ---
    PbImageSelector.prototype.setLoading = function (isLoading) {
      if (!this.dropzone) return;
      this.dropzone.classList.toggle("is-loading", !!isLoading);
      if (this.btn) this.btn.disabled = !!isLoading;
    };

    PbImageSelector.prototype._fileKey = function (file) {
      return (
        file && (file.fileIndex ?? "") !== ""
          ? String(file.fileIndex)
          : file?.imgLink || ""
      ).trim();
    };

    PbImageSelector.prototype._updateWrapper = function (wrapper, file) {
      const labelEl = wrapper.querySelector(".pb-image-selector__image-label");
      if (labelEl && labelEl.textContent !== (file?.imgName || "")) {
        labelEl.textContent = file?.imgName || "";
      }

      // Update <img> src/alt
      const imageBox = wrapper.querySelector(".pb-image-selector__image");
      if (imageBox) {
        let img = imageBox.querySelector("img.pb-image-selector__img");
        if (!img) {
          img = document.createElement("img");
          img.className = "pb-image-selector__img";
          img.decoding = "async";
          img.loading = "lazy";
          imageBox.textContent = "";
          imageBox.appendChild(img);
        }
        const nextSrc = file?.imgLink || "";
        const nextAlt = file?.imgName || "uploaded image";
        if (img.src !== nextSrc) img.src = nextSrc;
        if (img.alt !== nextAlt) img.alt = nextAlt;
      }

      // Keep useful metadata
      wrapper.dataset.index =
        file?.fileIndex != null ? String(file.fileIndex) : "";
      wrapper.dataset.key = this._fileKey(file);

      // Attach remove button listener
      const removeBtn = wrapper.querySelector(".pb-image-selector__remove");
      if (removeBtn) {
        // Remove old listeners to avoid duplicates
        removeBtn.replaceWith(removeBtn.cloneNode(true));
        const newRemoveBtn = wrapper.querySelector(
          ".pb-image-selector__remove",
        );
        newRemoveBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.removeFile(file);
        });
      }
    };

    PbImageSelector.prototype.render = function () {
      if (!this.results || !this.template) {
        return;
      }

      const files = Array.isArray(this.files) ? this.files : [];

      const existingWrappers = Array.from(
        this.results.querySelectorAll(".pb-image-selector__image-wrapper"),
      ).filter((el) => !el.closest("template"));

      const existingByKey = new Map();
      existingWrappers.forEach((el) => {
        const key = el.dataset.key || "";
        if (key) existingByKey.set(key, el);
      });

      // New keys set
      const newKeys = new Set(files.map((f) => this._fileKey(f)));

      // Remove wrappers that are no longer present
      existingWrappers.forEach((el) => {
        const key = el.dataset.key || "";
        if (!newKeys.has(key)) el.remove();
      });

      const currentWrappers = () =>
        Array.from(
          this.results.querySelectorAll(".pb-image-selector__image-wrapper"),
        ).filter((el) => !el.closest("template"));

      const downloadedImages = [];

      files.forEach((file, i) => {
        const key = this._fileKey(file);
        let wrapper = this.results.querySelector(
          `.pb-image-selector__image-wrapper[data-key="${CSS.escape(key)}"]`,
        );

        if (!wrapper) {
          const fragment = this.template.content.cloneNode(true);
          wrapper = fragment.querySelector(".pb-image-selector__image-wrapper");
          this._updateWrapper(wrapper, file);

          const siblings = currentWrappers();
          const refNode = siblings[i] || null; // null => append at end
          this.results.insertBefore(wrapper, refNode);
        } else {
          this._updateWrapper(wrapper, file);

          const siblings = currentWrappers();
          if (siblings[i] !== wrapper) {
            const refNode = siblings[i] || null;
            this.results.insertBefore(wrapper, refNode);
          }
        }

        downloadedImages.push({
          fileIndex: file.fileIndex,
          imgLink: file.imgLink,
          imgName: file.imgName,
        });
      });

      if (this.builder.storageState.fetched) {
        if (this.dataset.input == "Images") {
          this.builder.downloadedImages = downloadedImages;
        } else if (this.dataset.input.includes("Make it Heavenly Image")) {
          this.builder.heavenlyImage = downloadedImages;
        } else if (this.dataset.input.includes("Change Clothing Image")) {
          this.builder.clothingImage = downloadedImages;
        } else {
          this.builder.customBackgroundImage = downloadedImages;
        }
        this.builder.persistState();
      }

      // Multiple-images switcher logic
      if (this.dataset.input == "Images") {
        if (files.length > 1 && this.multipleImagesSwitcher) {
          const checkbox = this.multipleImagesSwitcher.querySelector("input");
          if (checkbox) {
            checkbox.classList.add("disabled");
            if (checkbox.checked === false) {
              const changeEvent = new Event("change", {
                bubbles: true,
                cancelable: true,
              });
              checkbox.dispatchEvent(changeEvent);
            }
          }
        } else if (files.length < 2 && this.multipleImagesSwitcher) {
          const cb = this.multipleImagesSwitcher.querySelector("input");
          if (cb) cb.classList.remove("disabled");
          if (typeof this.multipleImagesSwitcher.hideMessage === "function") {
            this.multipleImagesSwitcher.hideMessage();
          }
        }
      }

      if (files.length == +this.dataset.max) {
        this.classList.add("disabled");
      } else {
        this.classList.remove("disabled");
      }
    };

    PbImageSelector.prototype.createTemplateInstance = function (file) {
      const fragment = this.template.content.cloneNode(true);

      const wrapper = fragment.querySelector(
        ".pb-image-selector__image-wrapper",
      );
      const imageBox = fragment.querySelector(".pb-image-selector__image");
      const labelEl = fragment.querySelector(".pb-image-selector__image-label");

      const img = document.createElement("img");
      img.src = file?.imgLink || "";
      img.alt = file?.imgName || "uploaded image";
      img.className = "pb-image-selector__img";
      img.decoding = "async";
      img.loading = "lazy";

      if (imageBox) {
        imageBox.textContent = "";
        imageBox.appendChild(img);
      }

      if (labelEl) {
        labelEl.textContent = file?.imgName || "";
      }

      if (wrapper) {
        if (file?.fileIndex != null)
          wrapper.dataset.index = String(file.fileIndex);
        wrapper.__sourceCard = file?.element || null;
      }

      return fragment;
    };

    PbImageSelector.prototype.removeFile = function (file) {
      const key = this._fileKey(file);
      const currentFile = (this.files || []).find(
        (f) => this._fileKey(f) == key,
      );
      if (!currentFile) return;

      const removeBtn = file.element.querySelector(".gpo-f-rm");
      if (!removeBtn) return;

      removeBtn.click();
    };

    // --- Helpers ---
    PbImageSelector.prototype.emitChanged = function () {
      this.dispatchEvent(
        new CustomEvent("images:changed", {
          bubbles: true,
          detail: {
            images: this.images.map(({ name, size, type, url }) => ({
              name,
              size,
              type,
              url,
            })),
            count: this.images.length,
            max: this.maxFiles,
          },
        }),
      );
    };

    PbImageSelector.prototype.teardownObjectURLs = function () {
      this.images.forEach((img) => {
        try {
          URL.revokeObjectURL(img.url);
        } catch (_) {}
      });
    };

    // Hard clear: remove all files permanently
    PbImageSelector.prototype.clearAllFiles = function () {
      if (!Array.isArray(this.files) || this.files.length === 0) return;

      // Remove files via removeFile to simulate proper deletion
      [...this.files].forEach((file) => {
        this.removeFile(file);
      });

      this.files = [];
      this.render();
      this.emitChanged();
    };

    // Soft delete: keep a backup in temporaryDeletedFiles
    PbImageSelector.prototype.softDeleteAllFiles = function () {
      if (!Array.isArray(this.files) || this.files.length === 0) return;

      this.temporaryDeletedFiles = [...this.files]; // backup
      this.clearAllFiles();
    };

    // Restore previously soft-deleted files, one by one
    PbImageSelector.prototype.restoreSoftDeletedFiles = async function () {
      if (
        !Array.isArray(this.temporaryDeletedFiles) ||
        this.temporaryDeletedFiles.length === 0
      )
        return;

      // Sequentially re-add files to input (simulate user adding)
      for (const file of this.temporaryDeletedFiles) {
        await this._reAddFile(file);
      }

      this.temporaryDeletedFiles = []; // clear backup once restored
    };

    // Helper: simulate file re-adding
    PbImageSelector.prototype._reAddFile = function (file) {
      return new Promise((resolve) => {
        const dataTransfer = new DataTransfer();
        const input = this.input;

        if (!input) return resolve();

        // Try to fetch original blob if possible
        fetch(file.imgLink)
          .then((resp) => resp.blob())
          .then((blob) => {
            const restoredFile = new File(
              [blob],
              file.imgName || "restored.png",
              {
                type: blob.type || "image/png",
              },
            );
            dataTransfer.items.add(restoredFile);
            input.files = dataTransfer.files;

            const event = new Event("change", { bubbles: true });
            input.dispatchEvent(event);

            resolve();
          })
          .catch(() => resolve()); // fail gracefully
      });
    };

    PbImageSelector.prototype.showLimitMessage = function (text) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.classList.add("visible");
    };

    PbImageSelector.prototype.hideLimitMessage = function () {
      if (!this.message) return;
      this.message.textContent = "";
      this.message.classList.remove("visible");
    };

    PbImageSelector.prototype.builder =
      document.querySelector("portrait-builder");

    customElements.define("pb-image-selector", PbImageSelector);
  }

  if (!customElements.get("pb-product-switcher")) {
    class PbProductSwitcher extends HTMLElement {
      constructor() {
        super();
        this.initialState = this.dataset.checked == "true";
        this.handle = this.dataset?.handle;
        this._sellingPlan = null;
        this.sellingPlanData = null;
        this.elements = {};
        this.focus = this.dataset?.focus;
        this.imageSelector = this.dataset?.imageSelector;
        this.product = {
          title: this.dataset.title,
          price: +this.dataset?.price,
          variantId: this.dataset?.variantId,
          productId: this.dataset?.productId,
          notification: this.dataset?.notification,
          imageSelector: this.dataset?.imageSelector,
          quantity: this.dataset?.quantity,
        };
        this.onChange = this.onChange.bind(this);
        this.onCheckboxClick = this.onCheckboxClick.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        if (this.elements?.switcher) {
          this.elements.switcher.addEventListener("change", this.onChange);
        }
        if (this.elements?.additionalSwitcher) {
          this.elements.additionalSwitcher.addEventListener(
            "change",
            this.onCheckboxClick,
          );
        }
      }
    }

    PbProductSwitcher.prototype.setupElements = function () {
      this.elements.message = this.querySelector('[data-component="message"]');
      this.elements.switcher = this.querySelector(
        '[data-component="switcher"]',
      );
      this.elements.additionalSwitcher = this.querySelector(
        '[data-component="additional-switcher"]',
      );
      this.elements.customBg = document.querySelector(".pb-custom-bg");
      this.elements.nextBtn = document.querySelector(
        '.builder-step-btn[data-type="next"]',
      );
    };

    PbProductSwitcher.prototype.removeEventListeners = function () {
      if (this.elements?.switcher) {
        this.elements.switcher.removeEventListener("change", this.onChange);
      }
      if (this.elements?.additionalSwitcher) {
        this.elements.additionalSwitcher.removeEventListener(
          "change",
          this.onCheckboxClick,
        );
      }
    };

    PbProductSwitcher.prototype.onChange = function (e) {
      let isChecked = this.elements.switcher.checked;
      if (!this.elements.switcher) return;

      if (this.dataset.type == "radio") {
        if (this.elements.switcher.checked == true) {
          this.elements.customBg.classList.remove("hidden");
          this.elements.customBg
            .querySelector("pb-image-selector")
            ?.setAttribute("data-enable", "true");
        } else {
          this.elements.customBg?.classList?.add("hidden");
          this.elements.customBg
            .querySelector("pb-image-selector")
            ?.setAttribute("data-enable", "false");
        }
      }

      if (this.elements.switcher.classList.contains("disabled")) {
        this.showMessage();
        this.elements.switcher.checked = true;

        if (isChecked == false) {
          this.builder.removeAdditionalProduct(this.product);
        }
      }

      if (
        this.elements?.additionalSwitcher &&
        this.elements.switcher.checked ===
          this.elements?.additionalSwitcher?.checked
      ) {
        this.elements.additionalSwitcher.checked =
          !this.elements.additionalSwitcher.checked;
        this.elements.additionalSwitcher.dispatchEvent(
          new Event("change", { bubbles: true }),
        );
      }

      if (this.elements.switcher.checked == true) {
        this.builder.addAdditionalProduct(this.product);
      } else {
        this.builder.removeAdditionalProduct(this.product);
      }

      this.focusTarget(isChecked);
      this.handleImageSelector(this.elements.switcher.checked);
    };

    PbProductSwitcher.prototype.showMessage = function () {
      if (!this.elements?.message) return;
      this.elements.message.classList.add("visible");
    };

    PbProductSwitcher.prototype.handleImageSelector = function (checked) {
      if (!this.dataset?.imageSelector) return;
      const imageSelector =
        document.getElementById(this.dataset.imageSelector) ||
        document.getElementById(
          `image-selector-${this.dataset?.imageSelector}`,
        );
      if (!imageSelector) return;
      const imageSelectorWrapper = imageSelector.closest(
        ".pb-image-selector-wrapper",
      );
      if (checked) {
        if (imageSelectorWrapper)
          imageSelectorWrapper.classList.remove("hidden");
      } else {
        if (imageSelectorWrapper) imageSelectorWrapper.classList.add("hidden");
      }
    };

    PbProductSwitcher.prototype.hideMessage = function () {
      if (!this.elements?.message) return;
      this.elements.message.classList.remove("visible");
    };

    PbProductSwitcher.prototype.onCheckboxClick = function () {
      if (
        this.elements?.switcher &&
        this.elements.additionalSwitcher.checked ==
          this.elements.switcher.checked
      ) {
        this.elements.switcher.click();
      }
    };

    PbProductSwitcher.prototype.focusTarget = function (checked) {
      if (!this.focus || !checked) return;
      const target = document.querySelector(`${this.focus}`);
      if (!target) return;

      target.focus();
      scrollIntoView(target, "center");
    };

    PbProductSwitcher.prototype.getSellingPlanData = function () {
      try {
        const el = this.querySelector(`#selling-plan-${this.handle}`);
        if (!el) {
          this.sellingPlanData = null;
          return null;
        }

        const text = el.textContent?.trim();
        if (!text) {
          this.sellingPlanData = null;
          return null;
        }

        this.sellingPlanData = this.sellingPlanData || JSON.parse(text);
        return this.sellingPlanData;
      } catch (error) {
        console.error(
          `Error parsing selling plan data for handle ${this.handle}:`,
          error,
        );
        this.sellingPlanData = null;
        return null;
      }
    };

    PbProductSwitcher.prototype.builder =
      document.querySelector("portrait-builder");

    customElements.define("pb-product-switcher", PbProductSwitcher);
  }

  if (!customElements.get("pb-quantity")) {
    class PbQuantity extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          btns: null,
          input: null,
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onBtnClick = this.onBtnClick.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        if (this.elements.btns != null) {
          this.elements.btns.forEach((btn) => {
            btn.addEventListener("click", this.onBtnClick);
            btn.addEventListener("keydown", this.onKeyPress);
          });
        }

        if (this.elements.input != null) {
          this.elements.input.addEventListener("change", this.onInputChange);
          this.elements.input.addEventListener("input", this.onInputChange);
        }
      }
    }

    PbQuantity.prototype.setupElements = function () {
      this.elements.btns = this.querySelectorAll('[data-component="btn"]');
      this.elements.input = this.querySelector('[data-component="input"]');
    };

    PbQuantity.prototype.onInputChange = function (e) {
      if (!this.builder) return;

      const value = +e.target.value; // Ensure value is a number

      this.builder.setAttribute("data-quantity", value);

      const minusBtn = this.querySelector(
        '[data-component="btn"][data-type="minus"]',
      );
      if (value < 1) {
        minusBtn.setAttribute("disabled", "true"); // Disable minus button when value is 1
      } else {
        minusBtn.removeAttribute("disabled"); // Enable minus button when value is greater than 1
      }
    };

    PbQuantity.prototype.removeEventListeners = function () {
      if (this.elements.btns != null) {
        this.elements.btns.forEach((btn) => {
          btn.removeEventListener("click", this.onBtnClick);
          btn.removeEventListener("keydown", this.onKeyPress);
        });
      }

      if (this.elements.input != null) {
        this.elements.input.removeEventListener("change", this.onInputChange);
        this.elements.input.removeEventListener("input", this.onInputChange);
      }
    };

    PbQuantity.prototype.onBtnClick = function (e) {
      if (!this.elements.input) return;
      const value = this.elements.input.value;

      const btn = e.target;

      if (btn.dataset.type === "minus") {
        if (value > 0) {
          this.elements.input.value = +value - 1; // Decrease the value
        }
      } else if (btn.dataset.type === "plus") {
        this.elements.input.value = +value + 1; // Increase the value
      }

      // Trigger the input change handler after updating the value
      this.onInputChange({
        target: this.elements.input,
      });
    };

    PbQuantity.prototype.onKeyPress = function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.onBtnClick(e);
      }
    };

    PbQuantity.prototype.builder = document.querySelector("portrait-builder");

    customElements.define("pb-quantity", PbQuantity);
  }

  if (!customElements.get("pb-tips-product")) {
    class PbTipsProduct extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          option: null,
          values: null,
        };
        this.product = {
          title: this.dataset?.title,
          productId: this.dataset?.productId,
        };
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        this.addEventListener("click", this.onClick);
      }
    }

    PbTipsProduct.prototype.setupElements = function () {
      this.elements.option = this.querySelector(
        '[data-component="tips-option"]',
      );
      this.elements.values = this.querySelectorAll(
        '[data-component="tips-value"]',
      );

      if (!this.querySelector('[data-option-position="none"]')) {
        const noneOption = document.createElement("div");
        noneOption.textContent = "None";
        noneOption.dataset.component = "tips-value";
        noneOption.dataset.optionPosition = "none";
        noneOption.classList.add("tips-value", "none-option");

        this.elements.option.appendChild(noneOption);

        this.elements.values = this.querySelectorAll(
          '[data-component="tips-value"]',
        );
      }
    };

    PbTipsProduct.prototype.removeEventListeners = function () {
      this.removeEventListener("click", this.onClick);
    };

    PbTipsProduct.prototype.onClick = function (e) {
      const target = getEventTarget('[data-component="tips-value"]', e.target);
      if (!target || !this.builder) return;

      if (target.dataset.optionPosition === "none") {
        const selectedValue = this.querySelector(
          '[data-component="tips-value"].selected',
        );
        if (selectedValue) {
          selectedValue.classList.remove("selected");
        }
        target.classList.remove("selected");
        this.builder.removeAdditionalProduct(this.product);

        const changeStepEvent = new CustomEvent("builder:update-summary", {
          bubbles: true,
        });
        this.dispatchEvent(changeStepEvent);
        return;
      }

      const selectedValue = this.querySelector(
        '[data-component="tips-value"].selected',
      );
      const { optionPosition } = target.dataset;

      const currentVariant = this.getCurrentVariant(optionPosition);
      this.product.variantId = currentVariant.id;
      this.product.price = currentVariant.price;

      if (selectedValue == target) {
        target.classList.remove("selected");
        this.builder.removeAdditionalProduct(this.product);
      } else {
        if (selectedValue) {
          const currentVariant = this.getCurrentVariant(
            selectedValue.dataset.optionPosition,
          );
          this.product.variantId = currentVariant.id;
          this.product.price = currentVariant.price;
          this.builder.removeAdditionalProduct(this.product);
          selectedValue.classList.remove("selected");
        }
        const currentVariant = this.getCurrentVariant(optionPosition);
        this.product.variantId = currentVariant.id;
        this.product.price = currentVariant.price;
        this.product.quantity = 1;
        this.builder.addAdditionalProduct(this.product);
        this.builder.persistState();
        target.classList.add("selected");
      }
      const changeStepEvent = new CustomEvent("builder:update-summary", {
        bubbles: true,
      });
      this.dispatchEvent(changeStepEvent);
    };

    PbTipsProduct.prototype.getVariantData = function () {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector("#tips-product-variants").textContent);
      return this.variantData;
    };

    PbTipsProduct.prototype.getOptions = function () {
      this.optionsData =
        this.optionsData ||
        JSON.parse(this.querySelector("#tips-product-options").textContent);
      return this.optionsData;
    };

    PbTipsProduct.prototype.setCurrentVariant = function (product) {
      const variants = this.getVariantData();
      const options = this.getOptions();
      const currentVariant = variants.find((v) => v.id == product.variantId);
      let optionPosition;
      options[0].values.forEach((v, ind) => {
        if (v == currentVariant.option1) {
          optionPosition = ind;
        }
      });
      this.currentOptionPosition = optionPosition;
      this.querySelector(`[data-option-position="${optionPosition}"]`)?.click();
    };

    PbTipsProduct.prototype.getCurrentVariant = function (position) {
      const firstOption = this.getOptions()[0];
      const variants = this.getVariantData();

      const currentVariant = variants.find((v) => {
        return v.options[0] == firstOption.values[position];
      });

      return currentVariant;
    };

    PbTipsProduct.prototype.builder =
      document.querySelector("portrait-builder");

    customElements.define("pb-tips-product", PbTipsProduct);
  }

  if (!customElements.get("pb-custom-bg")) {
    class PbCustomBg extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          notification: null,
          imageSelector: null,
        };
      }

      connectedCallback() {
        this.setupElements();
      }

      disconnectedCallback() {}

      static get observedAttributes() {
        return ["data-enable"];
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === "data-enable" && oldValue !== newValue) {
          if (this.enable == "false") {
            this.clearNotification();
          }
        }
      }

      get enable() {
        return this.dataset.enable;
      }
    }

    PbCustomBg.prototype.setupElements = function () {
      this.elements.notification = this.querySelector(
        '[data-component="notification"]',
      );
      this.elements.imageSelector = this.querySelector("pb-image-selector");
    };

    PbCustomBg.prototype.clearNotification = function () {
      if (!this.elements.notification) return;
      (this, (this.elements.notification.value = ""));
    };

    customElements.define("pb-custom-bg", PbCustomBg);
  }

  if (!customElements.get("pb-purchase")) {
    class PbPurchase extends HTMLElement {
      constructor() {
        super();
        this._defaultSetup = false;
        this.elements = { template: null, wrapper: null, _purchaseBlock: null };
        this._itemsMap = new Map(); // id -> { el, input }
        this._order = []; // ordered input ids (for arrow-key nav)
        this._onOrigChange = this._onOrigChange.bind(this);
        this._virtualId = "__shop_pay__"; // id used only in custom UI
        this._virtualTargetId = null; // real input id that the virtual mirrors (first radio)
        this._activeId = null;
      }

      connectedCallback() {
        this.setupElements();
        this.onInit();
      }

      disconnectedCallback() {
        this._teardownOrigListeners();
      }

      get purchaseBlock() {
        if (!this.elements._purchaseBlock) {
          this.elements._purchaseBlock =
            document.querySelector("#downpay-product-wrapper") ||
            document.querySelector(".downpay-product-wrapper");
        }
        return this.elements._purchaseBlock;
      }
    }

    // --- Setup / init ---
    PbPurchase.prototype.setupElements = function () {
      this.elements.template = this.querySelector("template");
      this.elements.wrapper = this.querySelector(".pb-purchase__wrapper");
      if (!this.elements._purchaseBlock) {
        this.elements._purchaseBlock =
          document.querySelector("#downpay-product-wrapper") ||
          document.querySelector(".downpay-product-wrapper");
      }
    };

    PbPurchase.prototype.onInit = function () {
      // Give Downpay time to render radios
      setTimeout(() => {
        this.setupItems();
        this._wireOrigListeners();

        const MAX_DURATION = 2 * 60 * 1000; // 2 minutes
        const INTERVAL = 10 * 1000; // 10 seconds

        let elapsed = 0;

        const purchaseCheckInterval = setInterval(() => {
          const purchaseId =
            PORTRAIT_BUILDER?.storageState?.purchaseId?.trim?.();
          const defaultSetup = PORTRAIT_BUILDER?._defaultSetup;

          // Stop if already set up or no purchaseId yet
          if (!purchaseId || defaultSetup) {
            elapsed += INTERVAL;
            if (elapsed >= MAX_DURATION) clearInterval(purchaseCheckInterval);
            return;
          }

          const input = document.querySelector(
            `[data-input-id="${purchaseId}"]`,
          );

          if (input) {
            input.click();
            input.dispatchEvent(new Event("change", { bubbles: true }));
            PORTRAIT_BUILDER._defaultSetup = true; // mark as done
            clearInterval(purchaseCheckInterval); // stop checking
          } else {
            elapsed += INTERVAL;
            if (elapsed >= MAX_DURATION) {
              console.warn(
                "⏰ Purchase input not found within 2 minutes — stopped checking.",
              );
              clearInterval(purchaseCheckInterval);
            }
          }
        }, INTERVAL);
      }, 5000);
    };

    PbPurchase.prototype.setupItems = function () {
      const root = this.purchaseBlock;
      if (!root || !this.elements.template || !this.elements.wrapper) return;

      const options = root.querySelectorAll(".purchase-option");
      if (!options.length) return;

      this.classList.remove("hidden");

      // clear previous (keep template)
      Array.from(this.elements.wrapper.children).forEach((n) => {
        if (n !== this.elements.template) n.remove();
      });
      this._itemsMap.clear();
      this._order = [];
      this._virtualTargetId = null;

      // ----- real options -----
      options.forEach((opt, idx) => {
        const input = opt.querySelector('input[type="radio"]');
        const label = opt.querySelector("label");
        if (!input || !label) return;

        const id = input.id;
        const text = (label.textContent || "").trim();

        const frag = this.elements.template.content.cloneNode(true);
        const item = frag.querySelector(".pb-purchase__item");
        const textBox = frag.querySelector(".pb-purchase__text");

        if (idx === 0 && textBox) {
          textBox.innerHTML =
            "Pay in Full or From $39.99/mo with " +
            `<span class="pb-purchase__logo">${SHOP_PAY_BADGE_SVG}</span>`;
        } else if (textBox) {
          textBox.innerHTML = `<span class="pb-purchase__text-wrapper">
						${text}

					<pb-tooltip>
					
							<button class="pb-tooltip" popovertarget="purchase-tooltip" data-component="popover-btn">
								${TOOLTIP_ICON}
							</button>
							<div class="pb-tooltip__content" id="purchase-tooltip" popover>
								<div class="pb-tooltip__content-wrapper">
									You only pay full price if you love the final portrait.
								</div>
							</div>
					</pb-tooltip>
					</span>
					<div class="pb-purchase__message">
						Absolutely risk-free:
						<br>
							You only pay full price if you love the final portrait.
						<br>
						Not satisfied? No other payment needed. Cancel anytime.
					</div>
					`;
        }

        item.dataset.inputId = id;
        item.setAttribute("role", "radio");
        item.setAttribute("tabindex", "0");
        item.setAttribute("aria-checked", input.checked ? "true" : "false");
        if (input.checked) item.classList.add("checked");

        item.addEventListener("click", () =>
          this._selectById(id, { focus: false }),
        );
        item.addEventListener("keydown", (e) => {
          const k = e.key;
          if (k === " " || k === "Enter") {
            e.preventDefault();
            this._selectById(id, { focus: false });
          } else if (k === "ArrowRight" || k === "ArrowDown") {
            e.preventDefault();
            this._focusNext(id);
          } else if (k === "ArrowLeft" || k === "ArrowUp") {
            e.preventDefault();
            this._focusPrev(id);
          }
        });

        this.elements.wrapper.appendChild(frag);
        const rendered = this.elements.wrapper.lastElementChild;
        this._itemsMap.set(id, { el: rendered, input, isVirtual: false });
        this._order.push(id);

        // remember first real input id for virtual item
        if (idx === 0) this._virtualTargetId = id;
      });

      this.elements.wrapper.setAttribute("role", "radiogroup");

      // initial focus for keyboard UX
      const checkedRealId = this._order.find((oid) => {
        const entry = this._itemsMap.get(oid);
        return entry && !entry.isVirtual && entry.input?.checked;
      });
      if (checkedRealId) {
        const entry = this._itemsMap.get(checkedRealId);
        entry?.el.setAttribute("tabindex", "0");
        this._activeId = checkedRealId; // track current custom selection
      }
    };

    // --- Selection & syncing ---
    PbPurchase.prototype._selectById = function (id, { focus = true } = {}) {
      const entry = this._itemsMap.get(id);
      if (!entry) return;

      // If virtual, click the first real radio (target)
      if (entry.isVirtual) {
        entry.input?.click(); // fires native change on real input
        entry.input?.dispatchEvent(new Event("change", { bubbles: true }));
        this._activeId = this._virtualId; // keep virtual selected in custom UI
      } else {
        entry.input?.click();
        entry.input?.dispatchEvent(new Event("change", { bubbles: true }));
        this._activeId = id;
      }

      // Mirror UI
      this._setCheckedUI(this._activeId);

      if (focus) entry.el.focus();
    };

    PbPurchase.prototype._setCheckedUI = function (activeId) {
      this._itemsMap.forEach(({ el }, id) => {
        const isActive = id === activeId;
        el.classList.toggle("checked", isActive);
        el.setAttribute("aria-checked", isActive ? "true" : "false");
        el.setAttribute("tabindex", isActive ? "0" : "-1");
      });
    };

    PbPurchase.prototype._onOrigChange = function (e) {
      const changed = e.target;
      if (!changed?.id) return;

      // If the first real input changed and we *last* selected the virtual,
      // keep the virtual highlighted; otherwise, reflect the actual real choice.
      if (
        this._activeId === this._virtualId &&
        changed.id === this._virtualTargetId
      ) {
        this._setCheckedUI(this._virtualId);
      } else {
        this._activeId = changed.id;
        this._setCheckedUI(changed.id);
      }
    };

    // --- Arrow key navigation helpers ---
    PbPurchase.prototype._focusNext = function (currentId) {
      const idx = this._order.indexOf(currentId);
      if (idx === -1) return;
      const nextId = this._order[(idx + 1) % this._order.length];
      const nextEl = this._itemsMap.get(nextId)?.el;
      if (nextEl) nextEl.focus();
    };

    PbPurchase.prototype._focusPrev = function (currentId) {
      const idx = this._order.indexOf(currentId);
      if (idx === -1) return;
      const prevId =
        this._order[(idx - 1 + this._order.length) % this._order.length];
      const prevEl = this._itemsMap.get(prevId)?.el;
      if (prevEl) prevEl.focus();
    };

    // --- Listen to hidden radios (in case something else changes them) ---
    PbPurchase.prototype._wireOrigListeners = function () {
      const root = this.purchaseBlock;
      if (!root) return;
      this._origInputs = root.querySelectorAll(
        '.purchase-option input[type="radio"]',
      );
      this._origInputs.forEach((inp) =>
        inp.addEventListener("change", this._onOrigChange),
      );
    };

    PbPurchase.prototype._teardownOrigListeners = function () {
      if (!this._origInputs) return;
      this._origInputs.forEach((inp) =>
        inp.removeEventListener("change", this._onOrigChange),
      );
      this._origInputs = null; 
    };

    PbPurchase.prototype._onOrigChange = function (e) {
      const changed = e.target;
      if (!changed?.id) return;
      // reflect to custom UI
      this._setCheckedUI(changed.id);

      const changeStepEvent = new CustomEvent("builder:change-purchase", {
        detail: {
          purchaseId: changed.id,
        },
        bubbles: true,
      });
      this.dispatchEvent(changeStepEvent);
    };

    customElements.define("pb-purchase", PbPurchase);
  }

  if (!customElements.get("pb-summary-option")) {
    class PbSummaryOption extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          select: null,
        };
        this.onChange = this.onChange.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        const { select } = this.elements;
        if (select) {
          select.addEventListener("change", this.onChange);
        }
      }
    }

    PbSummaryOption.prototype.setupElements = function () {
      this.elements.select = this.querySelector('[data-component="select"]');
    };

    PbSummaryOption.prototype.removeEventListeners = function () {
      const { select } = this.elements;
      if (select) {
        select.removeEventListener("change", this.onChange);
      }
    };

    PbSummaryOption.prototype.onChange = function (e) {
      const value = e.target.value;
      const optionName = e.target?.dataset?.name || null;
      if (!optionName) return;

      const builderInput = document.querySelector(
        `pb-option[data-name="${optionName}"] [data-option-position="${value}"]`,
      );
      if (!builderInput) return;

      builderInput.click();
    };

    customElements.define("pb-summary-option", PbSummaryOption);
  }

  if (!customElements.get("pb-summary-images")) {
    class PbSummaryImages extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          btn: null,
        };
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        const btn = this.elements?.btn;
        if (btn) {
          btn?.addEventListener("click", this?.onClick);
          // btn?.addEventListener("keydown", this?.onKeyDown);
        }
      }
    }

    PbSummaryImages.prototype.setupElements = function () {
      this.elements.btn = this.querySelector('[data-component="edit-btn"]');
    };

    PbSummaryImages.prototype.onKeydown = function (e) {
      const btn = this.elements?.btn;
      if (!btn) return;

      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        btn.click();
      }
    };

    PbSummaryImages.prototype.onClick = function () {
      const fileIndex = this?.dataset?.fileIndex;
      if (fileIndex == null) return;

      const imageSelector = document.querySelector(
        `pb-image-selector[data-input="${fileIndex}"]`,
      );
      if (!imageSelector) return;

      const step = imageSelector.dataset?.step || null;
      const changeStepEvent = new CustomEvent("builder:change-step", {
        detail: {
          step,
        },
        bubbles: true,
      });
      this.dispatchEvent(changeStepEvent);
    };

    PbSummaryImages.prototype.removeEventListeners = function () {
      const btn = this.elements?.btn;
      if (btn) {
        btn.removeEventListener("click", this.onClick);
        btn.removeEventListener("keydown", this.onKeyDown);
      }
    };

    customElements.define("pb-summary-images", PbSummaryImages);
  }

  if (!customElements.get("pb-summary-product")) {
    class PbSummaryProduct extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          removeBtn: null,
          redirectBtn: null,
          select: null,
          switcher: null,
        };
        this.onRedirectBtnClick = this.onRedirectBtnClick.bind(this);
        this.onRemoveBtnClick = this.onRemoveBtnClick.bind(this);
        this.onSwitcherClick = this.onSwitcherClick.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.type = this.dataset?.type || null;
        this.productId = this.dataset?.productId || null;
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        const { removeBtn, switcher, redirectBtn, select } = this.elements;
        if (removeBtn) {
          removeBtn.addEventListener("click", this.onRemoveBtnClick);
        }
        if (switcher) {
          switcher.addEventListener("click", this.onSwitcherClick);
        }
        if (redirectBtn) {
          redirectBtn.addEventListener("click", this.onRedirectBtnClick);
        }
        if (select) {
          select.addEventListener("change", this.onSelectChange);
        }
      }
    }

    PbSummaryProduct.prototype.setupElements = function () {
      this.elements.removeBtn = this.querySelector(
        '[data-component="remove-btn"]',
      );
      this.elements.redirectBtn = this.querySelector(
        '[data-component="redirect"]',
      );
      this.elements.switcher = this.querySelector(
        '[data-component="switcher"]',
      );
      this.elements.select = this.querySelector('[data-component="select"]');
    };

    PbSummaryProduct.prototype.removeEventListeners = function () {
      const { removeBtn, switcher, redirectBtn, select } = this.elements;
      if (removeBtn) {
        removeBtn.removeEventListener("click", this.onRemoveBtnClick);
      }
      if (switcher) {
        switcher.removeEventListener("click", this.onSwitcherClick);
      }
      if (redirectBtn) {
        redirectBtn.removeEventListener("click", this.onRedirectBtnClick);
      }
      if (select) {
        select.removeEventListener("change", this.onSelectChange);
      }
    };

    PbSummaryProduct.prototype.onRemoveBtnClick = function (e) {
      const productId = this.productId;
      const type = this.type;
      if (!productId) return;
      const changeStepEvent = new CustomEvent(
        "builder:remove-additional-product",
        {
          detail: {
            productId,
            type,
          },
          bubbles: true,
        },
      );
      this.dispatchEvent(changeStepEvent);
    };

    PbSummaryProduct.prototype.onRedirectBtnClick = function () {
      const productId = this.productId;
      if (!productId) return;

      const productSwitcher = document.querySelector(
        `pb-product-switcher[data-product-id="${productId}"]`,
      );
      if (!productSwitcher) return;

      const step = productSwitcher?.dataset?.step || null;
      const changeStepEvent = new CustomEvent("builder:change-step", {
        detail: {
          step,
        },
        bubbles: true,
      });
      this.dispatchEvent(changeStepEvent);
    };

    PbSummaryProduct.prototype.onSwitcherClick = function (e) {
      const productId = this.productId;
      if (!productId) return;

      const switcher = e.target;
      const isChecked = switcher.checked;

      const removeProduct = new CustomEvent(
        "builder:remove-additional-product",
        {
          detail: { productId },
          bubbles: true,
        },
      );
      this.dispatchEvent(removeProduct);
      const stepElement = document.querySelector('[data-step="3"]');
      if (stepElement) {
        stepElement.click();
      }
    };

    PbSummaryProduct.prototype.onSelectChange = function (e) {
      const productId = this.productId;
      if (!productId) return;

      const productSwitcher = document.querySelector(
        `#pb-product-${productId}`,
      );
      if (!productSwitcher) return;

      const value = e.target.value;
      const productValue = productSwitcher.querySelector(
        `[data-option-position="${value}"]`,
      );
      if (!productValue || productValue?.classList?.contains("selected"))
        return;
      productValue.click();
    };

    PbSummaryProduct.prototype.onKeyDown = function () {};

    customElements.define("pb-summary-product", PbSummaryProduct);
  }

  if (!customElements.get("pb-summary-notification")) {
    class PbSummaryNotification extends HTMLElement {
      constructor() {
        super();
        this.title = this.dataset.title;
        this.elements = {
          textarea: null,
          saveBtn: null,
          editBtn: null,
          notification: null,
        };

        // Bind handlers
        this.onEditBtnClick = this.onEditBtnClick.bind(this);
        this.onSaveBtnClick = this.onSaveBtnClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        const { saveBtn, editBtn } = this.elements;

        if (editBtn) {
          editBtn.addEventListener("click", this.onEditBtnClick);
          editBtn.addEventListener("keydown", this.onKeyDown);
        }

        if (saveBtn) {
          saveBtn.addEventListener("click", this.onSaveBtnClick);
          saveBtn.addEventListener("keydown", this.onKeyDown);
        }
      }
    }

    // --- Setup ---
    PbSummaryNotification.prototype.setupElements = function () {
      this.elements.textarea =
        this.querySelector('[data-component="textarea"]') || null;
      this.elements.saveBtn =
        this.querySelector('[data-component="save-btn"]') || null;
      this.elements.editBtn =
        this.querySelector('[data-component="edit-btn"]') || null;

      this.elements.notification =
        this.closest("portrait-builder")?.querySelector(
          `[data-component="notification"][data-title="${this.title}"]`,
        ) || null;
    };

    // --- Events wiring ---

    PbSummaryNotification.prototype.removeEventListeners = function () {
      const { saveBtn, editBtn } = this.elements;

      if (editBtn) {
        editBtn.removeEventListener("click", this.onEditBtnClick);
        editBtn.removeEventListener("keydown", this.onKeyDown);
      }

      if (saveBtn) {
        saveBtn.removeEventListener("click", this.onSaveBtnClick);
        saveBtn.removeEventListener("keydown", this.onKeyDown);
      }
    };

    // --- Handlers ---
    PbSummaryNotification.prototype.onEditBtnClick = function () {
      this.classList.toggle("open");
    };

    PbSummaryNotification.prototype.onSaveBtnClick = function () {
      this.classList.remove("open");
      const { notification, textarea } = this.elements;

      if (!notification || !textarea) return;

      const value = textarea.value;
      notification.value = value;

      // Bubble events so form integrations pick them up
      notification.dispatchEvent(new Event("input", { bubbles: true }));
      notification.dispatchEvent(new Event("change", { bubbles: true }));
    };

    PbSummaryNotification.prototype.onKeyDown = function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (e.target === this.elements.editBtn) {
          this.onEditBtnClick();
        } else if (e.target === this.elements.saveBtn) {
          this.onSaveBtnClick();
        }
      }
    };

    customElements.define("pb-summary-notification", PbSummaryNotification);
  }

  if (!customElements.get("pb-summary-quantity")) {
    class PbSummaryQuantity extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          btnMinus: null,
          btnPlus: null,
          quantityBtnMinus: null,
          quantityBtnPlus: null,
        };

        // Bind handlers
        this.onBtnMinusClick = this.onBtnMinusClick.bind(this);
        this.onBtnPlusClick = this.onBtnPlusClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        const { btnMinus, btnPlus } = this.elements;

        if (btnMinus) {
          btnMinus.addEventListener("click", this.onBtnMinusClick);
          btnMinus.addEventListener("keydown", this.onKeyDown);
        }

        if (btnPlus) {
          btnPlus.addEventListener("click", this.onBtnPlusClick);
          btnPlus.addEventListener("keydown", this.onKeyDown);
        }
      }
    }

    customElements.define("pb-summary-quantity", PbSummaryQuantity);

    // --- Setup ---
    PbSummaryQuantity.prototype.setupElements = function () {
      this.elements.btnMinus = this.querySelector(
        '[data-component="btn-minus"]',
      );
      this.elements.btnPlus = this.querySelector('[data-component="btn-plus"]');
      this.elements.quantityBtnMinus = document.querySelector(
        '.pb-quantity [data-type="minus"]',
      );
      this.elements.quantityBtnPlus = document.querySelector(
        '.pb-quantity [data-type="plus"]',
      );
    };

    // --- Events wiring ---

    PbSummaryQuantity.prototype.removeEventListeners = function () {
      const { btnMinus, btnPlus } = this.elements;

      if (btnMinus) {
        btnMinus.removeEventListener("click", this.onBtnMinusClick);
        btnMinus.removeEventListener("keydown", this.onKeyDown);
      }

      if (btnPlus) {
        btnPlus.removeEventListener("click", this.onBtnPlusClick);
        btnPlus.removeEventListener("keydown", this.onKeyDown);
      }
    };

    // --- Handlers ---
    PbSummaryQuantity.prototype.onBtnMinusClick = function () {
      if (this.elements.quantityBtnMinus) {
        this.elements.quantityBtnMinus.click();
      }
    };

    PbSummaryQuantity.prototype.onBtnPlusClick = function () {
      if (this.elements.quantityBtnPlus) {
        this.elements.quantityBtnPlus.click();
      }
    };

    PbSummaryQuantity.prototype.onKeyDown = function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (e.target === this.elements.btnMinus) {
          this.onBtnMinusClick();
        } else if (e.target === this.elements.btnPlus) {
          this.onBtnPlusClick();
        }
      }
    };
  }

  if (!customElements.get("pb-tooltip")) {
    class PbTooltip extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          popover: null,
          popoverBtn: null,
        };

        // instance-level timeout reference
        this._hideTimeout = null;
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    }

    // --- Setup elements ---
    PbTooltip.prototype.setupElements = function () {
      this.elements.popover = this.querySelector("[popover]");
      this.elements.popoverBtn = this.querySelector(
        '[data-component="popover-btn"]',
      );
    };

    // --- Add listeners ---
    PbTooltip.prototype.addEventListeners = function () {
      const { popoverBtn, popover } = this.elements;
      if (!popoverBtn || !popover) return;

      this._onMouseEnter = this.onMouseEnter.bind(this);
      this._onMouseLeave = this.onMouseLeave.bind(this);

      popoverBtn.addEventListener("mouseenter", this._onMouseEnter);
      popoverBtn.addEventListener("mouseleave", this._onMouseLeave);
      popover.addEventListener("mouseenter", this._onMouseEnter);
      popover.addEventListener("mouseleave", this._onMouseLeave);
    };

    // --- Remove listeners ---
    PbTooltip.prototype.removeEventListeners = function () {
      const { popoverBtn, popover } = this.elements;
      if (!popoverBtn || !popover) return;

      popoverBtn.removeEventListener("mouseenter", this._onMouseEnter);
      popoverBtn.removeEventListener("mouseleave", this._onMouseLeave);
      popover.removeEventListener("mouseenter", this._onMouseEnter);
      popover.removeEventListener("mouseleave", this._onMouseLeave);
    };

    // --- Hover handlers ---
    PbTooltip.prototype.onMouseEnter = function () {
      const { popover, popoverBtn } = this.elements;
      if (!popover) return;

      clearTimeout(this._hideTimeout);

      if (!popover.matches(":popover-open")) {
        popover.showPopover({ source: popoverBtn });
      }
    };

    PbTooltip.prototype.onMouseLeave = function () {
      const { popover } = this.elements;
      if (popover?.matches(":popover-open")) {
        popover.hidePopover();
      }
    };

    customElements.define("pb-tooltip", PbTooltip);
  }

  // RESIZE TEXTAREA start
  const selector = ".js-autoresize";

  const resize = (el) => {
    if (!el) return;
    el.style.height = "auto";
    el.style.height = el.scrollHeight + 20 + "px";
  };

  const onInput = (e) => {
    const el = e.target;
    if (!el.matches(selector)) return;
    resize(el);
  };

  const init = () => {
    document.addEventListener("input", onInput, false);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
  // RESIZE TEXTAREA end

  const TOOLTIP_ICON = `
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
<rect width="22" height="22" rx="11" fill="white"/>
<rect width="22" height="22" rx="11" fill="#2283AF"/>
<path d="M9.84 8.5H11.296V15.5H9.84V8.5ZM10.582 7.485C10.358 7.485 10.1713 7.41267 10.022 7.268C9.87267 7.12333 9.798 6.94133 9.798 6.722C9.798 6.50733 9.87267 6.32767 10.022 6.183C10.1713 6.03367 10.3557 5.959 10.575 5.959C10.7897 5.959 10.9717 6.03367 11.121 6.183C11.2703 6.32767 11.345 6.50733 11.345 6.722C11.345 6.94133 11.2703 7.12333 11.121 7.268C10.9763 7.41267 10.7967 7.485 10.582 7.485Z" fill="white"/>
</svg>
	`;
})();
